(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1022],{

/***/ 85032:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "BI": function() { return /* binding */ getProductsBySkus; },
/* harmony export */   "jK": function() { return /* binding */ getCurrencySymbol; },
/* harmony export */   "jr": function() { return /* binding */ getDealsProductsBySkus; },
/* harmony export */   "ts": function() { return /* binding */ getCategoryCMSContent; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(50029);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(87794);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18517);
/* harmony import */ var _actionTypes_index__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1369);
/* harmony import */ var config_queries__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(91250);





var loadingState = {
  cms: {},
  products: {},
  currency: false
};
var getCategoryCMSContent = function getCategoryCMSContent(categoryId) {
  return /*#__PURE__*/function () {
    var _ref = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(dispatch, getState) {
      var _getState$pageBuilder;

      var state, dateCreated, _response$categories, _category$cms_block, response, category, payload;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              state = (_getState$pageBuilder = getState().pageBuilder.categoryCmsContent) === null || _getState$pageBuilder === void 0 ? void 0 : _getState$pageBuilder[categoryId];
              dateCreated = (state === null || state === void 0 ? void 0 : state.dateCreated) && new Date(state === null || state === void 0 ? void 0 : state.dateCreated);

              if (!((!dateCreated || new Date() - dateCreated > 1 * 60000) && !loadingState.cms[categoryId])) {
                _context.next = 11;
                break;
              }

              loadingState.cms[categoryId] = true;
              _context.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fetchGraphQLGetRequest */ .Z.fetchGraphQLGetRequest(config_queries__WEBPACK_IMPORTED_MODULE_3__/* .getCategoryCMS */ .qP, {
                id: categoryId
              });

            case 6:
              response = _context.sent;
              category = response === null || response === void 0 ? void 0 : (_response$categories = response.categories) === null || _response$categories === void 0 ? void 0 : _response$categories.items[0];
              payload = {
                content: (category === null || category === void 0 ? void 0 : (_category$cms_block = category.cms_block) === null || _category$cms_block === void 0 ? void 0 : _category$cms_block.content) || null,
                displayMode: (category === null || category === void 0 ? void 0 : category.display_mode) || null,
                name: (category === null || category === void 0 ? void 0 : category.name) || null,
                categoryId: categoryId,
                dateCreated: new Date()
              };
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_4__/* .GET_CATEGORY_CMS_CONTENT */ .Vs,
                payload: payload
              });
              loadingState.cms[categoryId] = false;

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};

var sortProducts = function sortProducts(skus, products) {
  var items = (products === null || products === void 0 ? void 0 : products.items) || [];
  items.sort(function (a, b) {
    var aIndex = skus.indexOf(a === null || a === void 0 ? void 0 : a.sku);
    var bIndex = skus.indexOf(b === null || b === void 0 ? void 0 : b.sku);
    return aIndex - bIndex;
  });
  return {
    items: items
  };
};

var getProductsBySkus = function getProductsBySkus(_ref2) {
  var skus = _ref2.skus,
      id = _ref2.id;
  return /*#__PURE__*/function () {
    var _ref3 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee2(dispatch, getState) {
      var state, dateCreated, _yield$ajaxServices$f, products, sortedProducts, payload;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = getState().pageBuilder.products[id];
              dateCreated = (state === null || state === void 0 ? void 0 : state.dateCreated) && new Date(state === null || state === void 0 ? void 0 : state.dateCreated);

              if (!((!dateCreated || new Date() - dateCreated > 1 * 60000) && !loadingState.products[id])) {
                _context2.next = 12;
                break;
              }

              loadingState.products[id] = true;
              _context2.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fetchGraphQLGetRequest */ .Z.fetchGraphQLGetRequest(config_queries__WEBPACK_IMPORTED_MODULE_3__/* .getProductsBySkus */ .BI, {
                skus: skus,
                pageSize: skus.length
              });

            case 6:
              _yield$ajaxServices$f = _context2.sent;
              products = _yield$ajaxServices$f.products;
              sortedProducts = sortProducts(skus, products);
              payload = {
                products: sortedProducts,
                id: id,
                dateCreated: new Date()
              };
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_4__/* .GET_PRODUCTS_BY_SKUS */ .l6,
                payload: payload
              });
              loadingState.products[id] = false;

            case 12:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function (_x3, _x4) {
      return _ref3.apply(this, arguments);
    };
  }();
};
var getDealsProductsBySkus = function getDealsProductsBySkus(_ref4) {
  var skus = _ref4.skus,
      id = _ref4.id;
  return /*#__PURE__*/function () {
    var _ref5 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee3(dispatch, getState) {
      var state, dateCreated, _yield$ajaxServices$f2, products, sortedProducts, payload;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              state = getState().pageBuilder.products[id];
              dateCreated = (state === null || state === void 0 ? void 0 : state.dateCreated) && new Date(state === null || state === void 0 ? void 0 : state.dateCreated);

              if (!((!dateCreated || new Date() - dateCreated > 1 * 60000) && !loadingState.products[id])) {
                _context3.next = 12;
                break;
              }

              loadingState.products[id] = true;
              _context3.next = 6;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fetchGraphQLGetRequest */ .Z.fetchGraphQLGetRequest(config_queries__WEBPACK_IMPORTED_MODULE_3__/* .getDealsProductsBySkus */ .jr, {
                skus: skus,
                pageSize: skus.length
              });

            case 6:
              _yield$ajaxServices$f2 = _context3.sent;
              products = _yield$ajaxServices$f2.products;
              sortedProducts = sortProducts(skus, products);
              payload = {
                products: sortedProducts,
                id: id,
                dateCreated: new Date()
              };
              dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_4__/* .GET_DEALS_PRODUCTS_BY_SKUS */ .Ev,
                payload: payload
              });
              loadingState.products[id] = false;

            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function (_x5, _x6) {
      return _ref5.apply(this, arguments);
    };
  }();
};
var getCurrencySymbol = function getCurrencySymbol() {
  return /*#__PURE__*/function () {
    var _ref6 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)( /*#__PURE__*/_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee4(dispatch, getState) {
      var currencySymbol, _yield$ajaxServices$f3, currency, _currencySymbol, payload;

      return _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_regenerator_index_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              currencySymbol = getState().pageBuilder.currencySymbol;

              if (!(!loadingState.currency && !currencySymbol)) {
                _context4.next = 11;
                break;
              }

              loadingState.currency = true;
              _context4.next = 5;
              return utils_ajaxServices__WEBPACK_IMPORTED_MODULE_1__/* ["default"].fetchGraphQLGetRequest */ .Z.fetchGraphQLGetRequest(config_queries__WEBPACK_IMPORTED_MODULE_3__/* .getCurrencySymbol */ .jK);

            case 5:
              _yield$ajaxServices$f3 = _context4.sent;
              currency = _yield$ajaxServices$f3.currency;
              _currencySymbol = currency === null || currency === void 0 ? void 0 : currency.base_currency_symbol;
              payload = {
                currencySymbol: _currencySymbol
              };
              _currencySymbol && dispatch({
                type: _actionTypes_index__WEBPACK_IMPORTED_MODULE_4__/* .GET_CURRENCY_SYMBOL */ .sM,
                payload: payload
              });
              loadingState.currency = false;

            case 11:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function (_x7, _x8) {
      return _ref6.apply(this, arguments);
    };
  }();
};

/***/ }),

/***/ 42130:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56209);
/* harmony import */ var _upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(79549);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var UpgradeCheckBar = function UpgradeCheckBar(props) {
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
  var imgUrl = props.btnLabel ? "".concat(imagePrefix, "/assets/images/upgrade-info.svg") : "".concat(imagePrefix, "/assets/images/success-circle-2.svg");
  var imgSize = 30;

  var renderType = function renderType() {
    switch (props.type) {
      case "info":
        return (_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar-info"]);

      default:
        return (_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar-success"]);
    }
  };

  var bannerTypeClass = renderType();
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
    className: "d-flex ".concat((_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["upgrade-check-bar"]), " ").concat(bannerTypeClass, " ").concat(props.className ? " " + props.className : ""),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)("div", {
      className: "d-flex",
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("img", {
        src: imgUrl,
        width: imgSize,
        height: imgSize
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        className: "".concat((_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default().message)),
        children: props.message
      })]
    }), props.btnLabel && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_CTAButton_CTAButton__WEBPACK_IMPORTED_MODULE_1__["default"], {
      className: "".concat((_upgradeCheckBar_module_scss__WEBPACK_IMPORTED_MODULE_3___default().ctaBtn), " p-0"),
      variant: "link white",
      handleClick: props.btnHandler,
      id: props.id,
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("span", {
        className: "d-none d-md-inline-block",
        children: props.btnLabel
      })
    })]
  });
};

UpgradeCheckBar.defaultProps = {
  className: "",
  type: "success"
};
/* harmony default export */ __webpack_exports__["Z"] = (UpgradeCheckBar);

/***/ }),

/***/ 52441:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(90609);
/* harmony import */ var _ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26125);
/* harmony import */ var _config_index__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_config_index__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(21608);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31555);
/* harmony import */ var _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(69152);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85893);









var ErrorCard = function ErrorCard(_ref) {
  var errorMsg = _ref.errorMsg,
      fullWidth = _ref.fullWidth;
  var env = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().env);
  var imagePrefix = (_config_index__WEBPACK_IMPORTED_MODULE_0___default().envConfigs)[env].imagePrefix;
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    if (errorMsg) {
      if (fullWidth === 1) {
        var heading = errorMsg.heading ? errorMsg.heading + ". " : "";
        var subHeading1 = errorMsg.subHeading1 ? errorMsg.subHeading1 + ". " : "";
        var subHeading2 = errorMsg.subHeading2 ? errorMsg.subHeading2 + ". " : "";
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU("".concat(heading).concat(subHeading1).concat(subHeading2));
      } else {
        _services_analyticsUtag__WEBPACK_IMPORTED_MODULE_1__/* .error */ .vU(errorMsg);
      }
    }
  }, []);

  var errorBlock = function errorBlock() {
    switch (fullWidth) {
      case 1:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.Fragment, {
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
            src: "".concat(imagePrefix, "/assets/images/close-black-icon.svg"),
            width: 66,
            height: 66
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__heading"]),
            children: errorMsg && errorMsg.heading ? errorMsg.heading : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__subheading"]),
            children: errorMsg && errorMsg.subHeading1 ? errorMsg.subHeading1 : ''
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("div", {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card__subheading"]),
            children: errorMsg && errorMsg.subHeading2 ? errorMsg.subHeading2 : ''
          })]
        });

      default:
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsxs)(react_bootstrap__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
          className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card-block"]),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-card-image"]),
            xs: 1,
            md: 1,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("img", {
              src: "".concat(imagePrefix, "/assets/images/close-black-icon.svg"),
              width: 27,
              height: 27
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
            className: (_ErrorCard_module_scss__WEBPACK_IMPORTED_MODULE_4___default()["error-sub-text"]),
            xs: 11,
            md: 11,
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__.jsx)("span", {
              children: errorMsg ? errorMsg : ''
            })
          })]
        });
    }
  };

  return errorBlock();
};

/* harmony default export */ __webpack_exports__["Z"] = (ErrorCard);

/***/ }),

/***/ 3304:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _atoms_checkBox_Checkbox__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(51707);
/* harmony import */ var _AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41708);
/* harmony import */ var _AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);






var AffordabilityFilterToggle = function AffordabilityFilterToggle(props) {
  var handleCheck = function handleCheck(flag) {
    props.handleCheck(flag);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsxs)(_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.CustomContainer, {
    className: props.boxClass ? props.boxClass : (_AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["wrapper-checkbox"]),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(_atoms_checkBox_Checkbox__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
      isChecked: props.check,
      id: props.id,
      check: props.checkboxLabel,
      count: "0",
      isBrand: "false",
      handleCheck: handleCheck,
      checkBoxLabelStyling: "brandLabelStyling"
    }), props.check && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)("div", {
      className: (_AffordabilityFilterToggle_module_scss__WEBPACK_IMPORTED_MODULE_3___default()["item-label"]),
      children: props.checkboxSubtext
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (AffordabilityFilterToggle);

/***/ }),

/***/ 40465:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Xj": function() { return /* binding */ mergeClasses; }
/* harmony export */ });
/* unused harmony export mergeClasses */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_possibleConstructorReturn_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63553);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);







var _excluded = (/* unused pure expression or super */ null && (["className", "classes"]));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }




var classify = function classify(defaultClasses) {
  return function (WrappedComponent) {
    var _class;

    return _class = /*#__PURE__*/function (_Component) {
      _inherits(_class, _Component);

      var _super = _createSuper(_class);

      function _class() {
        _classCallCheck(this, _class);

        return _super.apply(this, arguments);
      }

      _createClass(_class, [{
        key: "render",
        value: function render() {
          var _this$props = this.props,
              className = _this$props.className,
              classes = _this$props.classes,
              restProps = _objectWithoutProperties(_this$props, _excluded);

          var classNameAsObject = className ? {
            root: className
          } : null;
          var finalClasses = mergeClasses(defaultClasses, classNameAsObject, classes);
          return /*#__PURE__*/_jsx(WrappedComponent, _objectSpread(_objectSpread({}, restProps), {}, {
            classes: finalClasses
          }));
        }
      }]);

      return _class;
    }(Component), _defineProperty(_class, "displayName", "Classify(".concat(getDisplayName(WrappedComponent), ")")), _class;
  };
};



var mergeClasses = function mergeClasses() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return Object.assign.apply(Object, [{}].concat(args));
};

var getDisplayName = function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'Component';
};

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (classify)));

/***/ }),

/***/ 14185:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var handleHtmlContentClick = function handleHtmlContentClick(event) {
  var code = event === null || event === void 0 ? void 0 : event.code;
  var target = event === null || event === void 0 ? void 0 : event.target;
  var type = event === null || event === void 0 ? void 0 : event.type; // Check if element is clicked or using accepted keyboard event

  var shouldIntercept = type === 'click' || code === 'Enter' || code === 'Space'; // Intercept link clicks and check to see if the
  // destination is internal to avoid refreshing the page

  if ((target === null || target === void 0 ? void 0 : target.tagName) === 'A' && shouldIntercept) {
    event.preventDefault();
    var query = target.search,
        tabTarget = target.target,
        href = target.href;

    if (tabTarget && globalThis.open) {
      if (query) {
        globalThis.open(href + query);
      } else {
        globalThis.open(href);
      }
    } else {
      globalThis.location.assign(href);
    }
  }
};

/* harmony default export */ __webpack_exports__["Z"] = (handleHtmlContentClick);

/***/ }),

/***/ 57280:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16835);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4730);


var _excluded = ["type"];

var config = __webpack_require__(26125); // If the root template supplies the backend URL at runtime, use it directly


var _ref = globalThis.document || {},
    htmlElement = _ref.documentElement;

var _ref2 = htmlElement ? htmlElement.dataset : {},
    imageOptimizingOrigin = _ref2.imageOptimizingOrigin;

var alreadyOptimized = imageOptimizingOrigin === 'backend';
var env = config.EnvConfig;
var mediaBackend = "".concat(env.server, "/media"); // Tests if a URL begins with `http:` or `https:` or `data:`

var absoluteUrl = /^(data|http|https)?:/i; // Simple path joiner that guarantees one and only one slash between segments

var joinUrls = function joinUrls(base, url) {
  return (base.endsWith('/') ? base.slice(0, -1) : base) + '/' + (url.startsWith('/') ? url.slice(1) : url);
};

var mediaBases = new Map().set('image-product', 'catalog/product/').set('image-category', 'catalog/category/').set('image-swatch', 'attribute/swatch/');

var getFileType = function getFileType(url) {
  var fileName = url.pathname.split('/').reverse()[0];
  var fileType = fileName.split('.').reverse()[0];
  return fileType;
};
/**
 * Creates an "optimized" url for a provided relative url based on
 * requested media type and width. Any image URLs (whose type begins with
 * "image-" will also be optimized.)
 *
 * If a `type` is provided the `path` will be joined with the associated media
 * base.
 *  - `catalog/product/path/to/img.jpg`
 *
 * If a `width` is provided, "resize parameters" are added to the URL for
 * middlewares (either onboard or backend) to return using the desired width
 * and original media url.
 *  - `catalog/product/path/to/img.jpg?width=500&auto=webp&format=pjpg
 *
 * If only `path` is provided it is returned unaltered.
 *
 * @param {string} path - absolute or relative url to resource.
 * @param {Object} props - properties describing desired optimizations
 * @param {string} props.type - "image-product" or "image-category"
 * @param {number} props.width - the desired resize width of the image
 * @param {number} props.height - the desired resize height of the image
 * @param {number} props.quality - the desired quality of the image
 * @param {bool} props.crop - should the image be cropped
 * @param {string} props.fit - how should the image be fit with the dimensions: bounds, cover, crop
 */


var makeOptimizedUrl = function makeOptimizedUrl(path) {
  var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var type = _ref3.type,
      opts = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_objectWithoutProperties_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_ref3, _excluded);

  // Immediate return if there's no image optimization to attempt
  if (!type || !type.startsWith('image-')) {
    return path;
  }

  var _ref4 = globalThis.location || {},
      origin = _ref4.origin;

  var isAbsolute = absoluteUrl.test(path);
  var magentoBackendURL = env.server;
  var baseURL = new URL(path, mediaBackend); // If URL is relative and has a supported type, prepend media base onto path

  if (!isAbsolute && mediaBases.has(type)) {
    var mediaBase = mediaBases.get(type);

    if (!baseURL.pathname.includes(mediaBase)) {
      baseURL = new URL(joinUrls(mediaBase, path), mediaBackend);
    }
  }

  if (baseURL.href.startsWith(magentoBackendURL) && !alreadyOptimized) {
    // Replace URL base so optimization middleware can handle request
    baseURL = new URL(baseURL.href.slice(magentoBackendURL.length), origin);
  } // Append image optimization parameters


  var params = new URLSearchParams(baseURL.search);
  params.set('auto', 'webp'); // Use the webp format if available

  var imageFileType = getFileType(baseURL);

  if (imageFileType === 'png') {
    params.set('format', 'png'); // use png if webp is not available
  } else {
    params.set('format', 'pjpg'); // Use progressive JPG if webp is not available
  }

  Object.entries(opts).forEach(function (_ref5) {
    var _ref6 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];

    if (value !== undefined && value !== null) {
      params.set(key, value);
    }
  });
  baseURL.search = params.toString();

  if (baseURL.origin === origin) {
    return baseURL.href.slice(baseURL.origin.length);
  }

  return baseURL.href;
};

/* harmony default export */ __webpack_exports__["Z"] = (makeOptimizedUrl);

/***/ }),

/***/ 86716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ useMediaQuery; }
/* harmony export */ });
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


var matchMedia = globalThis.matchMedia;
var useMediaQuery = function useMediaQuery() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    mediaQueries: []
  };

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({}),
      styles = _useState[0],
      setStyles = _useState[1];

  var isMountedRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
  var mediaQueries = props.mediaQueries;
  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    isMountedRef.current = true;
    if (!mediaQueries) return;
    var mqlList = mediaQueries.map(function (_ref) {
      var media = _ref.media;
      return matchMedia(media);
    });

    var handleMatch = function handleMatch(query, i) {
      if (!isMountedRef.current) return;

      if (query.matches) {
        setStyles(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), mediaQueries[i].style);
        });
      } else {
        setStyles(function (prevState) {
          var filteredState = Object.keys(prevState).filter(function (key) {
            return mediaQueries[i].style[key] !== prevState[key];
          }).reduce(function (obj, key) {
            return _objectSpread(_objectSpread({}, obj), {}, (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, key, prevState[key]));
          }, {});
          return filteredState;
        });
      }
    };

    mqlList.forEach(function (mql, i) {
      if (mql.matches) {
        setStyles(function (prevState) {
          return _objectSpread(_objectSpread({}, prevState), mediaQueries[i].style);
        });
      }

      mql.addEventListener('change', function (query) {
        return handleMatch(query, i);
      });
    });
    return function () {
      isMountedRef.current = false;
      mqlList.forEach(function (mql, i) {
        mql.removeEventListener('change', function (query) {
          return handleMatch(query, i);
        });
      });
    };
  }, [mediaQueries]);
  return {
    styles: styles
  };
};

/***/ }),

/***/ 69979:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "E4": function() { return /* binding */ getTextAlign; },
/* harmony export */   "Nb": function() { return /* binding */ verticalAlignmentToFlex; },
/* harmony export */   "Wf": function() { return /* binding */ getMediaQueries; },
/* harmony export */   "Y9": function() { return /* binding */ getCssClasses; },
/* harmony export */   "cL": function() { return /* binding */ getVerticalAlignment; },
/* harmony export */   "ds": function() { return /* binding */ getIsHidden; },
/* harmony export */   "h3": function() { return /* binding */ getAdvanced; },
/* harmony export */   "mH": function() { return /* binding */ getMargin; },
/* harmony export */   "om": function() { return /* binding */ getBackgroundImages; },
/* harmony export */   "tQ": function() { return /* binding */ getPadding; },
/* harmony export */   "ub": function() { return /* binding */ getBorder; }
/* harmony export */ });
/* unused harmony exports flexToVerticalAlignment, cssToJSXStyle */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(59499);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(16835);
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27812);




function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function getBackgroundImages(node) {
  var images = node.getAttribute('data-background-images');
  var response = {
    desktopImage: null,
    mobileImage: null,
    backgroundSize: node.style.backgroundSize,
    backgroundPosition: node.style.backgroundPosition,
    backgroundAttachment: node.style.backgroundAttachment,
    backgroundRepeat: node.style.backgroundRepeat || 'repeat'
  };

  if (images) {
    var imagesStructure = JSON.parse(images.replace(/\\"/g, '"'));

    if (imagesStructure.desktop_image) {
      response.desktopImage = imagesStructure.desktop_image;
    }

    if (imagesStructure.mobile_image) {
      response.mobileImage = imagesStructure.mobile_image;
    }
  }

  return response;
}
var alignmentToFlex = {
  top: 'flex-start',
  middle: 'center',
  bottom: 'flex-end'
};
function getVerticalAlignment(node) {
  var verticalAlignment = null;

  if (node.style.justifyContent) {
    verticalAlignment = flexToVerticalAlignment(node.style.justifyContent);
  }

  return {
    verticalAlignment: verticalAlignment
  };
}
function verticalAlignmentToFlex(alignment) {
  return alignmentToFlex[alignment];
}
function flexToVerticalAlignment(flex) {
  var flexToAlignment = Object.assign.apply(Object, [{}].concat((0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(Object.entries(alignmentToFlex).map(function (_ref) {
    var _ref2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, 2),
        a = _ref2[0],
        b = _ref2[1];

    return (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, b, a);
  }))));
  return flexToAlignment[flex];
}
function getAdvanced(node) {
  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, getPadding(node)), getMargin(node)), getBorder(node)), getTextAlign(node)), getCssClasses(node)), getIsHidden(node));
}
function getPadding(node) {
  return {
    paddingTop: node.style.paddingTop,
    paddingRight: node.style.paddingRight,
    paddingBottom: node.style.paddingBottom,
    paddingLeft: node.style.paddingLeft
  };
}
function getMargin(node) {
  return {
    marginTop: node.style.marginTop,
    marginRight: node.style.marginRight,
    marginBottom: node.style.marginBottom,
    marginLeft: node.style.marginLeft
  };
}
function getBorder(node) {
  return {
    border: node.style.borderStyle,
    borderColor: node.style.borderColor,
    borderWidth: node.style.borderWidth,
    borderRadius: node.style.borderRadius
  };
}
function getTextAlign(node) {
  return {
    textAlign: node.style.textAlign
  };
}
function getCssClasses(node) {
  return {
    cssClasses: node.getAttribute('class') ? node.getAttribute('class').split(' ') : []
  };
}
function getIsHidden(node) {
  return {
    isHidden: node.style.display === 'none'
  };
}
function cssToJSXStyle(style) {
  var toCamelCase = function toCamelCase(str) {
    return str.replace(/-(.)/g, function (_, p) {
      return p.toUpperCase();
    });
  };

  var result = {};
  style.split(';').forEach(function (el) {
    var _el$split = el.split(':'),
        _el$split2 = (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_slicedToArray_js__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_el$split, 2),
        prop = _el$split2[0],
        value = _el$split2[1];

    if (prop) {
      result[toCamelCase(prop.trim())] = value.trim();
    }
  });
  return result;
}
function getMediaQueries(node) {
  var response = [];
  var dataset = Object.keys(node.dataset);
  var medias = dataset.filter(function (key) {
    return key.match(/media-/);
  }).map(function (key) {
    return node.dataset[key];
  });
  var styles = dataset.filter(function (key) {
    return key.match(/mediaStyle/);
  }).map(function (key) {
    return node.dataset[key];
  });
  medias.forEach(function (media, i) {
    response.push({
      media: media,
      style: cssToJSXStyle(styles[i])
    });
  });
  return {
    mediaQueries: response
  };
}

/***/ }),

/***/ 123:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSP": function() { return /* binding */ __N_SSP; },
  "default": function() { return /* binding */ products; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js + 3 modules
var toConsumableArray = __webpack_require__(27812);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js
var asyncToGenerator = __webpack_require__(50029);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(59499);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/regenerator/index.js
var regenerator = __webpack_require__(87794);
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./components/atoms/DependencyHelper.js + 81 modules
var DependencyHelper = __webpack_require__(28658);
// EXTERNAL MODULE: ./utils/ajaxServices.js + 6 modules
var ajaxServices = __webpack_require__(18517);
// EXTERNAL MODULE: ./config/queries.js
var queries = __webpack_require__(91250);
// EXTERNAL MODULE: ./services/filterService.js
var filterService = __webpack_require__(75887);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 20 modules
var es = __webpack_require__(14416);
// EXTERNAL MODULE: ./services/productListService.js + 1 modules
var productListService = __webpack_require__(98776);
// EXTERNAL MODULE: ./utils/helperServices.js + 3 modules
var helperServices = __webpack_require__(64036);
// EXTERNAL MODULE: ./config/labels.js
var labels = __webpack_require__(99599);
// EXTERNAL MODULE: ./services/analyticsUtag.js
var analyticsUtag = __webpack_require__(69152);
// EXTERNAL MODULE: ./services/pageService.js
var pageService = __webpack_require__(76173);
// EXTERNAL MODULE: ./services/renderComponent.js + 11 modules
var renderComponent = __webpack_require__(51859);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./components/atoms/Seo/Seo.js
var Seo = __webpack_require__(22505);
// EXTERNAL MODULE: ./Redux/actions/productCompareAction.js
var productCompareAction = __webpack_require__(13635);
// EXTERNAL MODULE: ./config/index.js
var config = __webpack_require__(26125);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./components/molecules/errorCard/ErrorCard.jsx
var ErrorCard = __webpack_require__(52441);
// EXTERNAL MODULE: ./services/breadcrumbService.js
var breadcrumbService = __webpack_require__(74425);
// EXTERNAL MODULE: ./Redux/actionTypes/index.js
var actionTypes = __webpack_require__(1369);
// EXTERNAL MODULE: ./config/types.js
var types = __webpack_require__(69842);
// EXTERNAL MODULE: ./config/constants.js
var constants = __webpack_require__(58223);
// EXTERNAL MODULE: ./components/organisms/AffordabilityFilterToggle/AffordabilityFilterToggle.jsx
var AffordabilityFilterToggle = __webpack_require__(3304);
// EXTERNAL MODULE: ./Redux/actions/upgradeAction.js
var upgradeAction = __webpack_require__(58486);
// EXTERNAL MODULE: ./components/atoms/upgradeCheckBar/upgradeCheckBar.jsx
var upgradeCheckBar = __webpack_require__(42130);
// EXTERNAL MODULE: ./utils/priceFilterUtils.js
var priceFilterUtils = __webpack_require__(96902);
// EXTERNAL MODULE: ./Redux/actions/navAction.js
var navAction = __webpack_require__(42220);
// EXTERNAL MODULE: ./node_modules/react-lazyload/lib/index.js
var lib = __webpack_require__(1216);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(4730);
// EXTERNAL MODULE: ./components/pageBuilder/lib/utils.js
var utils = __webpack_require__(69979);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Row/configAggregator.js



function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var configAggregator = (function (node, props) {
  // Determine which node holds the data for the appearance
  var dataNode = props.appearance === 'contained' ? node.childNodes[0] : node;
  var videoOverlayColor = props.appearance === 'full-width' || props.appearance === 'full-bleed' ? node.childNodes[0] && node.childNodes[0].getAttribute('data-video-overlay-color') : dataNode.childNodes[0] && dataNode.childNodes[0].getAttribute('data-video-overlay-color');
  var minHeight = dataNode.style.minHeight ? dataNode.style.minHeight : null;

  var containsDynamicBlock = (0,toConsumableArray/* default */.Z)(dataNode.childNodes).some(function (e) {
    return e.getAttribute('data-content-type') === 'dynamic_block';
  });

  return _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({
    minHeight: containsDynamicBlock ? null : minHeight
  }, (0,utils/* getVerticalAlignment */.cL)(dataNode)), {}, {
    backgroundColor: dataNode.style.backgroundColor ? dataNode.style.backgroundColor : null
  }, (0,utils/* getBackgroundImages */.om)(dataNode)), {}, {
    backgroundType: dataNode.getAttribute('data-background-type'),
    videoSrc: dataNode.getAttribute('data-video-src'),
    videoFallbackSrc: dataNode.getAttribute('data-video-fallback-src'),
    videoLoop: dataNode.getAttribute('data-video-loop') === 'true',
    videoPlayOnlyVisible: dataNode.getAttribute('data-video-play-only-visible') === 'true',
    videoLazyLoading: dataNode.getAttribute('data-video-lazy-load') === 'true',
    videoOverlayColor: videoOverlayColor || null
  }, (0,utils/* getAdvanced */.h3)(dataNode)), (0,utils/* getIsHidden */.ds)(node)), (0,utils/* getMediaQueries */.Wf)(dataNode));
});
// EXTERNAL MODULE: ./components/pageBuilder/lib/ContentTypes/Row/row.module.css
var row_module = __webpack_require__(82000);
var row_module_default = /*#__PURE__*/__webpack_require__.n(row_module);
// EXTERNAL MODULE: ./components/pageBuilder/lib/classify.js
var classify = __webpack_require__(40465);
// EXTERNAL MODULE: ./components/pageBuilder/lib/makeUrl.js
var makeUrl = __webpack_require__(57280);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/useDetectScrollWidth.js
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }


/**
 * A hook that will detect if there is a scrollbar will be added to the viewport and
 * will add its width value as a `--global-scrollbar-width` custom property to the body element,
 * which can be used to calculate the full width of the viewport.
 */
// Check if the browser will add a scrollbar to the viewport

var getScrollBarWidth = function getScrollBarWidth() {
  var innerElement = document.createElement('div');
  innerElement.style.cssText = 'width:100%;height:200px';
  var outerElement = document.createElement('div');
  outerElement.style.cssText = 'position:absolute;top:-50px;left:0px;visibility:hidden;width:50px;height:50px;overflow:hidden';
  outerElement.appendChild(innerElement);
  document.body.appendChild(outerElement);
  var widthWithoutScroll = innerElement.offsetWidth;
  outerElement.style.overflow = 'scroll';
  var widthWithScroll = innerElement.offsetWidth;
  if (widthWithoutScroll === widthWithScroll) widthWithScroll = innerElement.clientWidth;
  document.body.removeChild(outerElement);
  return widthWithoutScroll - widthWithScroll;
}; // Watching for body height changes, and setting custom property with scrollbar width, when scrollbar is present.


var createObserver = function createObserver(scrollBarWidth) {
  return new globalThis.ResizeObserver(function (entries) {
    var _iterator = _createForOfIteratorHelper(entries),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var entry = _step.value;

        if (entry.target.scrollHeight > globalThis.innerHeight) {
          entry.target.style.setProperty('--global-scrollbar-width', "".concat(scrollBarWidth, "px"));
        } else {
          entry.target.style.setProperty('--global-scrollbar-width', '0px');
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  });
};

globalThis.isScrollWidthObserverActive = false;
var useDetectScrollWidth = function useDetectScrollWidth() {
  (0,react.useLayoutEffect)(function () {
    if (globalThis.isObserverActive) {
      return;
    }

    var scrollBarWidth = getScrollBarWidth();
    var observer = typeof globalThis.ResizeObserver !== 'undefined' && scrollBarWidth !== 0 ? createObserver(scrollBarWidth) : null;

    if (observer) {
      observer.observe(document.body);
      globalThis.isScrollWidthObserverActive = true;
    }

    return function () {
      if (observer) {
        observer.disconnect();
        document.body.style.removeProperty('--global-scrollbar-width');
        globalThis.isScrollWidthObserverActive = false;
      }
    };
  }, []);
};
// EXTERNAL MODULE: ./components/pageBuilder/lib/useMediaQuery.js
var useMediaQuery = __webpack_require__(86716);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Row/row.js



function row_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function row_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? row_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : row_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }










var matchMedia = globalThis.matchMedia;

var Row = function Row(props) {
  var backgroundElement = (0,react.useRef)(null);

  var _useState = (0,react.useState)(null),
      bgImageStyle = _useState[0],
      setBgImageStyle = _useState[1];

  var classes = (0,classify/* useStyle */.Xj)((row_module_default()), props.classes);
  var appearance = props.appearance,
      verticalAlignment = props.verticalAlignment,
      minHeight = props.minHeight,
      backgroundColor = props.backgroundColor,
      desktopImage = props.desktopImage,
      mobileImage = props.mobileImage,
      backgroundSize = props.backgroundSize,
      backgroundPosition = props.backgroundPosition,
      backgroundAttachment = props.backgroundAttachment,
      backgroundRepeat = props.backgroundRepeat,
      textAlign = props.textAlign,
      border = props.border,
      borderColor = props.borderColor,
      borderWidth = props.borderWidth,
      borderRadius = props.borderRadius,
      marginTop = props.marginTop,
      marginRight = props.marginRight,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      mediaQueries = props.mediaQueries,
      paddingTop = props.paddingTop,
      paddingRight = props.paddingRight,
      paddingBottom = props.paddingBottom,
      paddingLeft = props.paddingLeft,
      children = props.children,
      _props$cssClasses = props.cssClasses,
      cssClasses = _props$cssClasses === void 0 ? [] : _props$cssClasses,
      videoOverlayColor = props.videoOverlayColor;

  var _useMediaQuery = (0,useMediaQuery/* useMediaQuery */.a)({
    mediaQueries: mediaQueries
  }),
      mediaQueryStyles = _useMediaQuery.styles;

  var image = desktopImage;

  if (mobileImage && matchMedia && matchMedia('(max-width: 768px)').matches) {
    image = mobileImage;
  }

  var dynamicStyles = {
    minHeight: minHeight,
    backgroundColor: backgroundColor,
    textAlign: textAlign,
    border: border,
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft
  };
  var videoOverlayStyles = {
    backgroundColor: videoOverlayColor
  };

  if (image) {
    dynamicStyles.backgroundImage = bgImageStyle;
    dynamicStyles.backgroundSize = backgroundSize;
    dynamicStyles.backgroundPosition = backgroundPosition;
    dynamicStyles.backgroundAttachment = backgroundAttachment;
    dynamicStyles.backgroundRepeat = backgroundRepeat;
  }

  if (verticalAlignment) {
    dynamicStyles.display = 'flex';
    dynamicStyles.justifyContent = (0,utils/* verticalAlignmentToFlex */.Nb)(verticalAlignment);
    dynamicStyles.flexDirection = 'column';
  }

  useDetectScrollWidth(); // Determine the containers width and optimize the image

  (0,react.useEffect)(function () {
    // Intelligently resize cover background images
    if (image && backgroundElement.current) {
      if (backgroundSize === 'cover') {
        var elementWidth = backgroundElement.current.offsetWidth;
        var elementHeight = backgroundElement.current.offsetHeight;
        setBgImageStyle("url(".concat((0,makeUrl/* default */.Z)(image, {
          type: 'image-wysiwyg',
          width: elementWidth,
          height: elementHeight,
          quality: 85,
          crop: false,
          fit: 'cover'
        }), ")"));
      } else {
        setBgImageStyle("url(".concat((0,makeUrl/* default */.Z)(image, {
          type: 'image-wysiwyg',
          quality: 85
        }), ")"));
      }
    }
  }, [backgroundSize, image, setBgImageStyle]);
  var videoOverlay = videoOverlayColor ? /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: classes.videoOverlay,
    style: videoOverlayStyles
  }) : null;

  if (cssClasses !== null && cssClasses !== void 0 && cssClasses.includes('category-tiles')) {
    var _children$, _children$$props, _children$$props$data, _children$$props$data2;

    var _backgroundColor = children === null || children === void 0 ? void 0 : (_children$ = children[0]) === null || _children$ === void 0 ? void 0 : (_children$$props = _children$.props) === null || _children$$props === void 0 ? void 0 : (_children$$props$data = _children$$props.data) === null || _children$$props$data === void 0 ? void 0 : (_children$$props$data2 = _children$$props$data.children) === null || _children$$props$data2 === void 0 ? void 0 : _children$$props$data2[0].backgroundColor;

    document.documentElement.style.setProperty('--category-tile-background-color', _backgroundColor);
  }

  if (appearance === 'full-bleed') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: backgroundElement,
      style: row_objectSpread(row_objectSpread(row_objectSpread({}, dynamicStyles), mediaQueryStyles), {}, {
        marginLeft: null,
        marginRight: null,
        '--pbRowMarginLeft': marginLeft,
        '--pbRowMarginRight': marginRight
      }),
      className: [classes.fullBleed, classes.root].concat((0,toConsumableArray/* default */.Z)(cssClasses)).join(' '),
      children: [videoOverlay, children]
    });
  }

  if (appearance === 'full-width') {
    return /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: backgroundElement,
      style: row_objectSpread(row_objectSpread(row_objectSpread({}, dynamicStyles), mediaQueryStyles), {}, {
        marginLeft: null,
        marginRight: null,
        '--pbRowMarginLeft': marginLeft,
        '--pbRowMarginRight': marginRight
      }),
      className: [classes.fullBleed, classes.root].concat((0,toConsumableArray/* default */.Z)(cssClasses)).join(' '),
      children: [videoOverlay, /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
        className: classes.contained,
        children: children
      })]
    });
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: [classes.contained].concat((0,toConsumableArray/* default */.Z)(cssClasses)).join(' '),
    children: /*#__PURE__*/(0,jsx_runtime.jsxs)("div", {
      ref: backgroundElement,
      style: row_objectSpread(row_objectSpread({}, dynamicStyles), mediaQueryStyles),
      children: [videoOverlay, children]
    })
  });
};

/* harmony default export */ var row = (Row);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Row/index.js

;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Column/configAggregator.js


function configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Column_configAggregator = (function (node) {
  return configAggregator_objectSpread(configAggregator_objectSpread(configAggregator_objectSpread(configAggregator_objectSpread({
    minHeight: node.style.minHeight ? node.style.minHeight : null,
    display: node.style.display,
    width: node.style.width,
    backgroundColor: node.style.backgroundColor
  }, (0,utils/* getMediaQueries */.Wf)(node)), (0,utils/* getAdvanced */.h3)(node)), (0,utils/* getBackgroundImages */.om)(node)), (0,utils/* getVerticalAlignment */.cL)(node));
});
// EXTERNAL MODULE: ./components/pageBuilder/lib/ContentTypes/Column/column.module.css
var column_module = __webpack_require__(43772);
var column_module_default = /*#__PURE__*/__webpack_require__.n(column_module);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Column/column.js



function column_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function column_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? column_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : column_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }







var column_matchMedia = globalThis.matchMedia;

var Column = function Column(props) {
  var classes = (0,classify/* useStyle */.Xj)((column_module_default()), props.classes);

  var _useState = (0,react.useState)(null),
      bgImageStyle = _useState[0],
      setBgImageStyle = _useState[1];

  var columnElement = (0,react.useRef)(null);
  var appearance = props.appearance,
      backgroundAttachment = props.backgroundAttachment,
      backgroundColor = props.backgroundColor,
      backgroundPosition = props.backgroundPosition,
      _props$backgroundRepe = props.backgroundRepeat,
      backgroundRepeat = _props$backgroundRepe === void 0 ? 'repeat' : _props$backgroundRepe,
      backgroundSize = props.backgroundSize,
      border = props.border,
      borderColor = props.borderColor,
      borderRadius = props.borderRadius,
      borderWidth = props.borderWidth,
      children = props.children,
      _props$cssClasses = props.cssClasses,
      cssClasses = _props$cssClasses === void 0 ? [] : _props$cssClasses,
      desktopImage = props.desktopImage,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      marginRight = props.marginRight,
      marginTop = props.marginTop,
      mediaQueries = props.mediaQueries,
      minHeight = props.minHeight,
      mobileImage = props.mobileImage,
      paddingBottom = props.paddingBottom,
      paddingLeft = props.paddingLeft,
      paddingRight = props.paddingRight,
      paddingTop = props.paddingTop,
      textAlign = props.textAlign,
      verticalAlignment = props.verticalAlignment,
      width = props.width;

  var _useMediaQuery = (0,useMediaQuery/* useMediaQuery */.a)({
    mediaQueries: mediaQueries
  }),
      mediaQueryStyles = _useMediaQuery.styles;

  var image = desktopImage;

  if (mobileImage && column_matchMedia && column_matchMedia('(max-width: 768px)').matches) {
    image = mobileImage;
  }

  var flexDirection = 'column';
  var display = 'flex';
  var alignSelf;

  switch (appearance) {
    case 'align-top':
      alignSelf = 'flex-start';
      break;

    case 'align-center':
      alignSelf = 'center';
      break;

    case 'align-bottom':
      alignSelf = 'flex-end';
      break;

    case 'full-height':
    default:
      alignSelf = 'stretch';
      break;
  }

  var justifyContent;

  switch (verticalAlignment) {
    case 'top':
    default:
      justifyContent = 'flex-start';
      break;

    case 'middle':
      justifyContent = 'center';
      break;

    case 'bottom':
      justifyContent = 'flex-end';
      break;
  }

  var dynamicStyles = {
    alignSelf: alignSelf,
    backgroundColor: backgroundColor,
    border: border,
    borderColor: borderColor,
    borderRadius: borderRadius,
    borderWidth: borderWidth,
    display: display,
    flexDirection: flexDirection,
    justifyContent: justifyContent,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    marginRight: marginRight,
    marginTop: marginTop,
    minHeight: minHeight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft,
    paddingRight: paddingRight,
    paddingTop: paddingTop,
    textAlign: textAlign,
    verticalAlignment: verticalAlignment,
    width: width
  };

  if (image) {
    dynamicStyles.backgroundImage = bgImageStyle;
    dynamicStyles.backgroundSize = backgroundSize;
    dynamicStyles.backgroundPosition = backgroundPosition;
    dynamicStyles.backgroundAttachment = backgroundAttachment;
    dynamicStyles.backgroundRepeat = backgroundRepeat;
  } // Determine the containers width and optimize the image


  (0,react.useEffect)(function () {
    if (image && columnElement.current) {
      if (backgroundSize === 'cover') {
        setBgImageStyle("url(".concat((0,makeUrl/* default */.Z)(image, {
          type: 'image-wysiwyg',
          width: columnElement.current.offsetWidth,
          height: columnElement.current.offsetHeight,
          quality: 85,
          crop: false,
          fit: 'cover'
        }), ")"));
      } else {
        setBgImageStyle("url(".concat((0,makeUrl/* default */.Z)(image, {
          type: 'image-wysiwyg',
          quality: 85
        }), ")"));
      }
    }
  }, [backgroundSize, image, setBgImageStyle]);
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: column_objectSpread(column_objectSpread({}, dynamicStyles), mediaQueryStyles),
    ref: columnElement,
    className: [classes.root].concat((0,toConsumableArray/* default */.Z)(cssClasses)).join(' '),
    children: children
  });
};

/* harmony default export */ var column = (Column);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Column/index.js

;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnGroup/configAggregator.js
/* harmony default export */ var ColumnGroup_configAggregator = (function (node) {
  return {
    display: node.style.display
  };
});
// EXTERNAL MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnGroup/columnGroup.module.css
var columnGroup_module = __webpack_require__(390);
var columnGroup_module_default = /*#__PURE__*/__webpack_require__.n(columnGroup_module);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnGroup/columnGroup.js





var ColumnGroup = function ColumnGroup(props) {
  var classes = (0,classify/* useStyle */.Xj)((columnGroup_module_default()), props.classes);
  var display = props.display,
      children = props.children;
  var dynamicStyles = {
    display: display
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: dynamicStyles,
    className: classes.root,
    children: children
  });
};

/* harmony default export */ var columnGroup = (ColumnGroup);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnGroup/index.js

;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Image/configAggregator.js


function Image_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Image_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Image_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Image_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Image_configAggregator = (function (node) {
  if (!node.childNodes[0]) {
    return {};
  }

  var imageNode = node.childNodes[0].nodeName === 'A' ? node.childNodes[0].childNodes : node.childNodes;

  var getImageData = function getImageData(imageNode) {
    var imageDimension = null;

    try {
      imageDimension = JSON.parse(imageNode.getAttribute('data-image-dimensions'));
    } catch (e) {// Do nothing
    }

    return {
      src: imageNode.getAttribute('src'),
      dimensions: imageDimension
    };
  };

  var getImageProps = function getImageProps() {
    var image = imageNode[0];
    var imageProps = {
      desktopImage: null,
      mobileImage: null,
      altText: null,
      title: null
    };

    if (image) {
      var imageData = getImageData(image);

      if (image.getAttribute('data-element') === 'desktop_image') {
        imageProps.desktopImage = imageData;
        var image2 = imageNode[1];

        if (image2.getAttribute('data-element') === 'mobile_image' && image2.getAttribute('src') !== imageData.src) {
          imageProps.mobileImage = getImageData(image2);
        }
      } else {
        // If there is no desktop image
        imageProps.mobileImage = imageData;
      }

      imageProps.altText = image.getAttribute('alt');
      imageProps.title = image.getAttribute('title');
      imageProps = Image_configAggregator_objectSpread(Image_configAggregator_objectSpread({}, imageProps), (0,utils/* getBorder */.ub)(image));
    }

    return imageProps;
  };

  var props = Image_configAggregator_objectSpread(Image_configAggregator_objectSpread(Image_configAggregator_objectSpread(Image_configAggregator_objectSpread(Image_configAggregator_objectSpread(Image_configAggregator_objectSpread(Image_configAggregator_objectSpread(Image_configAggregator_objectSpread({}, getImageProps()), {}, {
    openInNewTab: node.childNodes[0].getAttribute('target') === '_blank'
  }, (0,utils/* getPadding */.tQ)(node)), (0,utils/* getMargin */.mH)(node)), imageNode[0] ? (0,utils/* getBorder */.ub)(imageNode[0]) : []), (0,utils/* getCssClasses */.Y9)(node)), (0,utils/* getTextAlign */.E4)(node)), (0,utils/* getIsHidden */.ds)(node)), (0,utils/* getMediaQueries */.Wf)(node));

  if (node.childNodes[0].nodeName === 'A') {
    props.link = node.childNodes[0].getAttribute('href');
    props.linkType = node.childNodes[0].getAttribute('data-link-type');
  }

  var captionElement = node.querySelector('figcaption');

  if (captionElement) {
    props.caption = captionElement.textContent;
  }

  return props;
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Text/configAggregator.js


function Text_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Text_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Text_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Text_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Text_configAggregator = (function (node) {
  return Text_configAggregator_objectSpread({
    content: node.innerHTML
  }, (0,utils/* getAdvanced */.h3)(node));
});
// EXTERNAL MODULE: ./components/pageBuilder/lib/ContentTypes/Text/text.module.css
var text_module = __webpack_require__(31338);
var text_module_default = /*#__PURE__*/__webpack_require__.n(text_module);
// EXTERNAL MODULE: ./node_modules/react-router/esm/react-router.js + 3 modules
var react_router = __webpack_require__(32147);
// EXTERNAL MODULE: ./components/pageBuilder/lib/handleHtmlContentClick.js
var handleHtmlContentClick = __webpack_require__(14185);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/resolveLinkProps.js
var resolveLinkProps_config = __webpack_require__(26125);

var env = resolveLinkProps_config.EnvConfig;
var backendUrl = env.server;
/* harmony default export */ var resolveLinkProps = (function (link) {
  var isExternalUrl;
  var linkProps = {};

  try {
    var baseUrlObj = new URL(backendUrl);
    var urlObj = new URL(link, baseUrlObj);
    isExternalUrl = baseUrlObj.host !== urlObj.host;

    if (isExternalUrl) {
      linkProps['href'] = link;
    } else {
      linkProps['href'] = urlObj.pathname;
    }
  } catch (e) {
    linkProps['href'] = link;
  }

  return linkProps;
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/htmlStringImgUrlConverter.js
function htmlStringImgUrlConverter_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = htmlStringImgUrlConverter_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function htmlStringImgUrlConverter_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return htmlStringImgUrlConverter_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return htmlStringImgUrlConverter_arrayLikeToArray(o, minLen); }

function htmlStringImgUrlConverter_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }




var htmlStringImgUrlConverter = function htmlStringImgUrlConverter(htmlString) {
  var temporaryElement = document.createElement('div');
  temporaryElement.innerHTML = htmlString;

  var _iterator = htmlStringImgUrlConverter_createForOfIteratorHelper(temporaryElement.getElementsByTagName('img')),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var imgElement = _step.value;
      imgElement.src = (0,makeUrl/* default */.Z)(imgElement.src, {
        type: 'image-wysiwyg',
        quality: 85
      });
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  var _iterator2 = htmlStringImgUrlConverter_createForOfIteratorHelper(temporaryElement.getElementsByTagName('a')),
      _step2;

  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var linkElement = _step2.value;
      var linkProps = resolveLinkProps(linkElement.href);
      linkElement.href = linkProps.to || linkProps.href;
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }

  return temporaryElement.innerHTML;
};

/* harmony default export */ var lib_htmlStringImgUrlConverter = (htmlStringImgUrlConverter);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Text/text.js









var toHTML = function toHTML(str) {
  return {
    __html: lib_htmlStringImgUrlConverter(str)
  };
};

var Text = function Text(props) {
  var classes = (0,classify/* useStyle */.Xj)((text_module_default()), props.classes);
  var content = props.content,
      textAlign = props.textAlign,
      border = props.border,
      borderColor = props.borderColor,
      borderWidth = props.borderWidth,
      borderRadius = props.borderRadius,
      marginTop = props.marginTop,
      marginRight = props.marginRight,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      paddingTop = props.paddingTop,
      paddingRight = props.paddingRight,
      paddingBottom = props.paddingBottom,
      paddingLeft = props.paddingLeft,
      _props$cssClasses = props.cssClasses,
      cssClasses = _props$cssClasses === void 0 ? [] : _props$cssClasses;
  var dynamicStyles = {
    textAlign: textAlign,
    border: border,
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft
  };
  var history = (0,react_router/* useHistory */.k6)();

  var clickHandler = function clickHandler(event) {
    (0,handleHtmlContentClick/* default */.Z)(history, event);
  };

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: dynamicStyles,
    className: [classes.root].concat((0,toConsumableArray/* default */.Z)(cssClasses)).join(' '),
    dangerouslySetInnerHTML: toHTML(content),
    onClick: clickHandler,
    onKeyDown: clickHandler,
    role: "presentation"
  });
};

/* harmony default export */ var Text_text = (Text);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Text/index.js

;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Tabs/configAggregator.js


function Tabs_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Tabs_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Tabs_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Tabs_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Tabs_configAggregator = (function (node) {
  var navigationEl = node.childNodes[0];
  var headerEls = navigationEl.childNodes;
  var headers = Array.from(headerEls, function (headerEl) {
    return headerEl.textContent;
  });
  var contentEl = node.childNodes[1];
  var alignmentMatch = /tab-align-([a-zA-Z]*)/.exec(node.getAttribute('class'));
  var tabNavigationAlignment = alignmentMatch ? alignmentMatch[1] : null;
  return Tabs_configAggregator_objectSpread(Tabs_configAggregator_objectSpread(Tabs_configAggregator_objectSpread(Tabs_configAggregator_objectSpread(Tabs_configAggregator_objectSpread(Tabs_configAggregator_objectSpread(Tabs_configAggregator_objectSpread(Tabs_configAggregator_objectSpread({
    defaultIndex: node.getAttribute('data-active-tab') ? parseInt(node.getAttribute('data-active-tab'), 10) : 0,
    minHeight: contentEl.style.minHeight,
    tabNavigationAlignment: tabNavigationAlignment || 'left',
    headers: headers
  }, (0,utils/* getVerticalAlignment */.cL)(node)), (0,utils/* getMargin */.mH)(node)), (0,utils/* getTextAlign */.E4)(contentEl)), (0,utils/* getPadding */.tQ)(node)), (0,utils/* getBorder */.ub)(contentEl)), (0,utils/* getIsHidden */.ds)(node)), (0,utils/* getCssClasses */.Y9)(node)), (0,utils/* getMediaQueries */.Wf)(contentEl));
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/TabItem/configAggregator.js


function TabItem_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function TabItem_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? TabItem_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : TabItem_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var TabItem_configAggregator = (function (node) {
  return TabItem_configAggregator_objectSpread(TabItem_configAggregator_objectSpread(TabItem_configAggregator_objectSpread(TabItem_configAggregator_objectSpread({
    tabName: node.getAttribute('data-tab-name'),
    minHeight: node.style.minHeight
  }, (0,utils/* getVerticalAlignment */.cL)(node)), {}, {
    backgroundColor: node.style.backgroundColor
  }, (0,utils/* getBackgroundImages */.om)(node)), (0,utils/* getAdvanced */.h3)(node)), (0,utils/* getMediaQueries */.Wf)(node));
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Products/configAggregator.js



function Products_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Products_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Products_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Products_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Products_configAggregator = (function (node, props) {
  var forms = node.querySelectorAll('.product-item-actions > .actions-primary > form');
  var carouselConfig = {};

  if (props.appearance === 'carousel') {
    carouselConfig = {
      autoplay: node.getAttribute('data-autoplay') === 'true',
      autoplaySpeed: parseInt(node.getAttribute('data-autoplay-speed')),
      infinite: node.getAttribute('data-infinite-loop') === 'true',
      arrows: node.getAttribute('data-show-arrows') === 'true',
      dots: node.getAttribute('data-show-dots') === 'true',
      carouselMode: node.getAttribute('data-carousel-mode'),
      centerPadding: node.getAttribute('data-center-padding'),
      slidesToScroll: 1
    };
  }

  return Products_configAggregator_objectSpread(Products_configAggregator_objectSpread({
    skus: (0,toConsumableArray/* default */.Z)(forms).map(function (form) {
      return form.getAttribute('data-product-sku');
    })
  }, carouselConfig), (0,utils/* getAdvanced */.h3)(node));
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Buttons/configAggregator.js


function Buttons_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Buttons_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Buttons_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Buttons_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Buttons_configAggregator = (function (node) {
  return Buttons_configAggregator_objectSpread({
    isSameWidth: node.getAttribute('data-same-width') === 'true'
  }, (0,utils/* getAdvanced */.h3)(node));
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ButtonItem/configAggregator.js


function ButtonItem_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function ButtonItem_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ButtonItem_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ButtonItem_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var ButtonItem_configAggregator = (function (node) {
  var props = ButtonItem_configAggregator_objectSpread(ButtonItem_configAggregator_objectSpread({
    display: node.style.display,
    text: node.textContent,
    textAlign: node.style.textAlign,
    openInNewTab: node.childNodes[0].getAttribute('target') === '_blank'
  }, (0,utils/* getAdvanced */.h3)(node.childNodes[0])), (0,utils/* getCssClasses */.Y9)(node));

  var buttonType;

  if (node.childNodes[0].classList.contains('pagebuilder-button-secondary')) {
    buttonType = 'secondary';
  } else if (node.childNodes[0].classList.contains('pagebuilder-button-link')) {
    buttonType = 'link';
  } else {
    buttonType = 'primary';
  }

  props.buttonType = buttonType;

  if (node.childNodes[0].nodeName === 'A') {
    props.link = node.childNodes[0].getAttribute('href');
    props.linkType = node.childNodes[0].getAttribute('data-link-type');
  }

  return props;
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Html/configAggregator.js


function Html_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Html_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Html_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Html_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Html_configAggregator = (function (node) {
  var html;

  if (node.dataset.decoded) {
    html = node.innerHTML;

    if (false) {}
  } else {
    var dom = new DOMParser().parseFromString('<!doctype html><body>' + node.textContent, 'text/html');
    html = dom.body.innerHTML;
  }

  return Html_configAggregator_objectSpread({
    html: html
  }, (0,utils/* getAdvanced */.h3)(node));
});
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/Video/configAggregator.js


function Video_configAggregator_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function Video_configAggregator_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? Video_configAggregator_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Video_configAggregator_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }


/* harmony default export */ var Video_configAggregator = (function (node) {
  var iframe = node.querySelector('iframe');
  var video = node.querySelector('video');
  var wrapper = node.querySelector('[data-element="wrapper"]');
  return Video_configAggregator_objectSpread(Video_configAggregator_objectSpread(Video_configAggregator_objectSpread(Video_configAggregator_objectSpread(Video_configAggregator_objectSpread(Video_configAggregator_objectSpread({
    url: iframe && iframe.getAttribute('src') || video && video.getAttribute('src') || null,
    autoplay: !!(video && video.getAttribute('autoplay') === 'true'),
    muted: !!(video && video.getAttribute('muted') === 'true'),
    maxWidth: node.childNodes[0].style.maxWidth || null
  }, (0,utils/* getTextAlign */.E4)(node)), (0,utils/* getMargin */.mH)(node)), (0,utils/* getBorder */.ub)(wrapper)), (0,utils/* getPadding */.tQ)(wrapper)), (0,utils/* getCssClasses */.Y9)(node)), (0,utils/* getIsHidden */.ds)(node));
});
// EXTERNAL MODULE: ./components/atoms/button/ButtonComponent.js + 1 modules
var ButtonComponent = __webpack_require__(33757);
// EXTERNAL MODULE: ./components/pageBuilder/lib/ContentTypes/ButtonItem/buttonItem.module.css
var buttonItem_module = __webpack_require__(78328);
var buttonItem_module_default = /*#__PURE__*/__webpack_require__.n(buttonItem_module);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ButtonItem/buttonItem.js


function buttonItem_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function buttonItem_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? buttonItem_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : buttonItem_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }









var ButtonItem = function ButtonItem(props) {
  var classes = (0,classify/* useStyle */.Xj)((buttonItem_module_default()), props.classes);
  var categoryCmsContent = (0,es/* useSelector */.v9)(function (state) {
    return state.pageBuilder.categoryCmsContent;
  });
  var buttonType = props.buttonType,
      link = props.link,
      _props$openInNewTab = props.openInNewTab,
      openInNewTab = _props$openInNewTab === void 0 ? false : _props$openInNewTab,
      text = props.text,
      textAlign = props.textAlign,
      border = props.border,
      borderColor = props.borderColor,
      borderWidth = props.borderWidth,
      borderRadius = props.borderRadius,
      marginTop = props.marginTop,
      marginRight = props.marginRight,
      marginBottom = props.marginBottom,
      marginLeft = props.marginLeft,
      paddingTop = props.paddingTop,
      paddingRight = props.paddingRight,
      paddingBottom = props.paddingBottom,
      paddingLeft = props.paddingLeft,
      _props$cssClasses = props.cssClasses,
      cssClasses = _props$cssClasses === void 0 ? [] : _props$cssClasses;
  var dynamicInnerStyles = {
    textAlign: textAlign,
    border: border,
    borderColor: borderColor,
    borderWidth: borderWidth,
    borderRadius: borderRadius,
    marginTop: marginTop,
    marginRight: marginRight,
    marginBottom: marginBottom,
    marginLeft: marginLeft,
    paddingTop: paddingTop,
    paddingRight: paddingRight,
    paddingBottom: paddingBottom,
    paddingLeft: paddingLeft
  };

  var handleClick = function handleClick(event) {
    if (link && buttonType === 'link') {
      var _categoryCmsContent$c;

      var query = new URLSearchParams(window.location.search);
      var categoryId = query.get('range') || query.get('category');
      var clickedItem = event.target.innerText;
      analyticsUtag/* link */.p4(buttonItem_objectSpread({
        link_type: "o",
        page_tool_event: "use",
        page_tool_name: "shopping: ".concat((_categoryCmsContent$c = categoryCmsContent[categoryId]) === null || _categoryCmsContent$c === void 0 ? void 0 : _categoryCmsContent$c.name, ": ").concat(clickedItem)
      }, analyticsUtag/* getUtagData */.GS(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
      window.location.href = link;
    }
  };

  var justifyMap = {
    left: 'flex-start',
    center: 'center',
    right: 'flex-end'
  };

  if (textAlign) {
    dynamicInnerStyles.justifyContent = justifyMap[textAlign] || 'center';
    dynamicInnerStyles.textAlign = textAlign;
  }

  var buttonProps = {
    onBtnClick: handleClick
  };

  if (buttonType === 'link') {
    buttonProps.className = classes.linkButton;
  }

  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    className: cssClasses.length ? cssClasses.join(' ') : undefined,
    children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonComponent/* default */.Z, buttonItem_objectSpread(buttonItem_objectSpread({}, buttonProps), {}, {
      button: true,
      text: text
    }))
  });
};

/* harmony default export */ var buttonItem = (ButtonItem);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ButtonItem/index.js

;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnLine/configAggregator.js
/* harmony default export */ var ColumnLine_configAggregator = (function (node) {
  return {
    display: node.style.display
  };
});
// EXTERNAL MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnLine/columnLine.module.css
var columnLine_module = __webpack_require__(37699);
var columnLine_module_default = /*#__PURE__*/__webpack_require__.n(columnLine_module);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnLine/columnLine.js





var ColumnLine = function ColumnLine(props) {
  var classes = (0,classify/* useStyle */.Xj)((columnLine_module_default()), props.classes);
  var display = props.display,
      children = props.children;
  var dynamicStyles = {
    display: display
  };
  return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
    style: dynamicStyles,
    className: classes.root,
    children: children
  });
};

/* harmony default export */ var columnLine = (ColumnLine);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/ContentTypes/ColumnLine/index.js

;// CONCATENATED MODULE: ./components/pageBuilder/lib/config.js




















var contentTypesConfig = {
  row: {
    configAggregator: configAggregator,
    component: row
  },
  column: {
    configAggregator: Column_configAggregator,
    component: column
  },
  'column-group': {
    configAggregator: ColumnGroup_configAggregator,
    component: columnGroup
  },
  'column-line': {
    configAggregator: ColumnLine_configAggregator,
    component: columnLine
  },
  image: {
    configAggregator: Image_configAggregator,
    component: /*#__PURE__*/react.lazy(function () {
      return __webpack_require__.e(/* import() */ 6501).then(__webpack_require__.bind(__webpack_require__, 56501));
    })
  },
  text: {
    configAggregator: Text_configAggregator,
    component: Text_text
  },
  tabs: {
    configAggregator: Tabs_configAggregator,
    component: /*#__PURE__*/react.lazy(function () {
      return __webpack_require__.e(/* import() */ 9749).then(__webpack_require__.bind(__webpack_require__, 59749));
    })
  },
  'tab-item': {
    configAggregator: TabItem_configAggregator,
    component: /*#__PURE__*/react.lazy(function () {
      return __webpack_require__.e(/* import() */ 8854).then(__webpack_require__.bind(__webpack_require__, 8854));
    })
  },
  buttons: {
    configAggregator: Buttons_configAggregator,
    component: /*#__PURE__*/react.lazy(function () {
      return __webpack_require__.e(/* import() */ 6809).then(__webpack_require__.bind(__webpack_require__, 26809));
    })
  },
  'button-item': {
    configAggregator: ButtonItem_configAggregator,
    component: buttonItem
  },
  products: {
    configAggregator: Products_configAggregator,
    component: /*#__PURE__*/react.lazy(function () {
      return Promise.all(/* import() */[__webpack_require__.e(6066), __webpack_require__.e(1248)]).then(__webpack_require__.bind(__webpack_require__, 1248));
    })
  },
  html: {
    configAggregator: Html_configAggregator,
    component: /*#__PURE__*/react.lazy(function () {
      return __webpack_require__.e(/* import() */ 4666).then(__webpack_require__.bind(__webpack_require__, 94666));
    })
  },
  video: {
    configAggregator: Video_configAggregator,
    component: /*#__PURE__*/react.lazy(function () {
      return __webpack_require__.e(/* import() */ 1860).then(__webpack_require__.bind(__webpack_require__, 51860));
    })
  }
};
function getContentTypeConfig(contentType) {
  if (contentTypesConfig[contentType]) {
    return contentTypesConfig[contentType];
  }
}
function setContentTypeConfig(contentType, config) {
  return contentTypesConfig[contentType] = config;
}
;// CONCATENATED MODULE: ./components/pageBuilder/lib/factory.js


var _excluded = ["isHidden"];

function factory_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function factory_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? factory_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : factory_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var renderContentType = function renderContentType(Component, data) {
  return /*#__PURE__*/(0,jsx_runtime.jsx)(Component, factory_objectSpread(factory_objectSpread({}, data), {}, {
    children: data.children.map(function (childTreeItem, i) {
      if ((childTreeItem === null || childTreeItem === void 0 ? void 0 : childTreeItem.contentType) === 'products') {
        childTreeItem.isDeals = childTreeItem.cssClasses.includes('deals');
      }

      return /*#__PURE__*/(0,jsx_runtime.jsx)(ContentTypeFactory, {
        data: childTreeItem
      }, i);
    })
  }));
};

var ContentTypeFactory = function ContentTypeFactory(_ref) {
  var data = _ref.data;

  var isHidden = data.isHidden,
      props = (0,objectWithoutProperties/* default */.Z)(data, _excluded);

  if (isHidden) {
    return null;
  }

  var contentTypeConfig = getContentTypeConfig(props.contentType);

  if (contentTypeConfig && contentTypeConfig.component) {
    var Component = renderContentType(contentTypeConfig.component, props);
    return /*#__PURE__*/(0,jsx_runtime.jsx)(react.Suspense, {
      fallback: /*#__PURE__*/(0,jsx_runtime.jsx)(jsx_runtime.Fragment, {}),
      children: Component
    });
  }

  return null;
};

/* harmony default export */ var factory = (ContentTypeFactory);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/parseStorageHtml.js


var createContentTypeObject = function createContentTypeObject(type, node) {
  return {
    contentType: type,
    appearance: node ? node.getAttribute('data-appearance') : null,
    id: node ? node.getAttribute('data-id') : null,
    children: []
  };
};

var walk = function walk(rootEl, contentTypeStructureObj) {
  var tree = document.createTreeWalker(rootEl, NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_TEXT);
  var currentNode = tree.nextNode();

  while (currentNode) {
    if (currentNode.nodeType !== Node.ELEMENT_NODE) {
      currentNode = tree.nextNode();
      continue;
    }

    var contentType = currentNode.getAttribute('data-content-type');

    if (!contentType) {
      currentNode = tree.nextNode();
      continue;
    }

    var props = createContentTypeObject(contentType, currentNode);
    var contentTypeConfig = getContentTypeConfig(contentType);

    if (contentTypeConfig && typeof contentTypeConfig.configAggregator === 'function') {
      try {
        Object.assign(props, contentTypeConfig.configAggregator(currentNode, props));
      } catch (e) {
        console.error("Failed to aggregate config for content type ".concat(contentType, "."), e);
      }
    } else {
      console.warn("Page Builder ".concat(contentType, " content type is not supported, this content will not be rendered."));
    }

    contentTypeStructureObj.children.push(props);
    walk(currentNode, props);
    currentNode = tree.nextSibling();
  }

  return contentTypeStructureObj;
};

var pbStyleAttribute = 'data-pb-style';
var bodyId = 'html-body';

var convertToInlineStyles = function convertToInlineStyles(document) {
  var styleBlocks = document.getElementsByTagName('style');
  var styles = {};
  var mediaStyles = {};

  if (styleBlocks.length > 0) {
    Array.from(styleBlocks).forEach(function (styleBlock) {
      var cssRules = styleBlock.sheet.cssRules;
      Array.from(cssRules).forEach(function (rule) {
        if (rule instanceof CSSStyleRule) {
          var selectors = rule.selectorText.split(',').map(function (selector) {
            return selector.trim();
          });
          selectors.forEach(function (selector) {
            if (!styles[selector]) {
              styles[selector] = [];
            }

            styles[selector].push(rule.style);
          });
        } else if (rule instanceof CSSMediaRule) {
          Array.from(rule.media).forEach(function (media) {
            var styles = Array.from(rule.cssRules).map(function (rule) {
              return {
                selectors: rule.selectorText.split(',').map(function (selector) {
                  return selector.trim();
                }),
                css: rule.style.cssText
              };
            });
            mediaStyles[media] = styles;
          });
        }
      });
    });
  }

  Object.keys(mediaStyles).map(function (media, i) {
    mediaStyles[media].forEach(function (style) {
      style.selectors.forEach(function (selector) {
        var element = document.querySelector(selector);

        if (element) {
          element.setAttribute("data-media-".concat(i), media);
          var savedStyles = element.getAttribute("data-media-style-".concat(i)); // avoids overwriting previously saved styles

          element.setAttribute("data-media-style-".concat(i), "".concat(savedStyles ? "".concat(savedStyles, " ") : '').concat(style.css));
        }
      });
    });
  });
  Object.keys(styles).map(function (selector) {
    var element = document.querySelector(selector);

    if (!element) {
      return;
    }

    styles[selector].map(function (style) {
      element.setAttribute('style', element.style.cssText + style.cssText);
    });
    element.setAttribute('data-id', element.getAttribute(pbStyleAttribute));
    element.removeAttribute(pbStyleAttribute);
  });
};

var parseStorageHtml = function parseStorageHtml(htmlStr) {
  var container = new DOMParser().parseFromString(htmlStr, 'text/html');
  var stageContentType = createContentTypeObject('root-container');
  container.body.id = bodyId;
  convertToInlineStyles(container);
  return walk(container.body, stageContentType);
};

/* harmony default export */ var lib_parseStorageHtml = (parseStorageHtml);
;// CONCATENATED MODULE: ./components/pageBuilder/lib/pagebuilder.js




function PageBuilder(_ref) {
  var html = _ref.html;
  var data = (0,react.useMemo)(function () {
    return lib_parseStorageHtml(html);
  }, [html]);
  return data.children.map(function (child, i) {
    return /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
      children: /*#__PURE__*/(0,jsx_runtime.jsx)(factory, {
        data: child
      })
    }, i);
  });
}
// EXTERNAL MODULE: ./Redux/actions/pageBuilderActions.js
var pageBuilderActions = __webpack_require__(85032);
;// CONCATENATED MODULE: ./pages/shopping/products.js




function products_createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = products_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function products_unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return products_arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return products_arrayLikeToArray(o, minLen); }

function products_arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }



function products_ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function products_objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? products_ownKeys(Object(source), !0).forEach(function (key) { (0,defineProperty/* default */.Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : products_ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
































 // import { Logger } from "utils/logger";




var ProductRangeContainer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(4945), __webpack_require__.e(9564)]).then(__webpack_require__.bind(__webpack_require__, 59564));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(59564)];
    }
  }
});
var SearchContainer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(9322), __webpack_require__.e(5951), __webpack_require__.e(857)]).then(__webpack_require__.bind(__webpack_require__, 64911));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(64911)];
    }
  }
});
var BrowseContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1275).then(__webpack_require__.bind(__webpack_require__, 11275));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(11275)];
    }
  }
});
var ProductListContainer = dynamic_default()(function () {
  return Promise.all(/* import() */[__webpack_require__.e(280), __webpack_require__.e(9220)]).then(__webpack_require__.bind(__webpack_require__, 45027));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(45027)];
    }
  }
});
var StickyBottomContainer = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 1433).then(__webpack_require__.bind(__webpack_require__, 81433));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(81433)];
    }
  }
});
var ButtonGroup = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 6035).then(__webpack_require__.bind(__webpack_require__, 76035));
}, {
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(76035)];
    }
  }
});
var BreadCrumb = dynamic_default()(function () {
  return __webpack_require__.e(/* import() */ 2426).then(__webpack_require__.bind(__webpack_require__, 55120));
}, {
  ssr: false,
  loadableGenerated: {
    webpack: function webpack() {
      return [/*require.resolve*/(55120)];
    }
  }
});

var ProductListPage = function ProductListPage(props) {
  var _selectedFilter11, _selectedFilter12, _productList, _selectedFilter15, _selectedFilter16, _props$upgrade9, _props$upgrade10, _props$upgrade11, _props$upgrade12, _props$upgrade12$cred, _selectedFilter23, _selectedFilter24, _props$upgrade14, _props$upgrade14$cred, _props$upgrade15, _props$upgrade15$cred, _props$sections;

  var dispatch = (0,DependencyHelper.useDispatch)();
  var router = (0,next_router.useRouter)();
  var categoryCmsContent = (0,es/* useSelector */.v9)(function (state) {
    return state.pageBuilder.categoryCmsContent;
  });

  var _useState = (0,react.useState)(true),
      cmsLoading = _useState[0],
      setCmsLoading = _useState[1];

  var _useState2 = (0,react.useState)(),
      categoryCMS = _useState2[0],
      setCategoryCMS = _useState2[1];

  var _useState3 = (0,react.useState)(),
      categoryDisplayMode = _useState3[0],
      setCategoryDisplayMode = _useState3[1];

  var _useState4 = (0,react.useState)(),
      categoryName = _useState4[0],
      setCategoryName = _useState4[1];

  var dynamicRoute = (0,helperServices/* dynamicBreadCrumb */.sz)();

  var _useState5 = (0,react.useState)(false),
      showComp = _useState5[0],
      setshowComp = _useState5[1];

  var _useState6 = (0,react.useState)(false),
      viewExecuted = _useState6[0],
      setViewExecuted = _useState6[1];

  var _useState7 = (0,react.useState)(),
      maxMonthlyPrice = _useState7[0],
      setMaxPrice = _useState7[1];

  var _useState8 = (0,react.useState)({}),
      priceValue = _useState8[0],
      _setPriceValue = _useState8[1];

  var _useState9 = (0,react.useState)(""),
      priceType = _useState9[0],
      _setPriceType = _useState9[1];

  var _useState10 = (0,react.useState)(false),
      priceReset = _useState10[0],
      setPriceReset = _useState10[1];

  var _useState11 = (0,react.useState)({}),
      sectionLvls = _useState11[0],
      setSectionLvls = _useState11[1];

  var _useState12 = (0,react.useState)(false),
      showQualifyProducts = _useState12[0],
      setShowQualifyProducts = _useState12[1];

  var _useState13 = (0,react.useState)(false),
      isProductsUpgrade = _useState13[0],
      setIsProductsUpgrade = _useState13[1];

  var pageName = "shopping: devices: product grid";
  var productListLoaded = (0,react.useRef)(false);
  var aggregationsLoaded = (0,react.useRef)(false);

  var _useState14 = (0,react.useState)({}),
      productList = _useState14[0],
      setProductList = _useState14[1];

  var _useState15 = (0,react.useState)(props.selectedFilter),
      selectedFilter = _useState15[0],
      setSelectedFilter = _useState15[1];

  var _useState16 = (0,react.useState)(),
      selectedCategory = _useState16[0],
      setSelectedCategory = _useState16[1];

  var _useState17 = (0,react.useState)([]),
      allBrands = _useState17[0],
      setAllBrands = _useState17[1];

  var _useState18 = (0,react.useState)([]),
      allPromotions = _useState18[0],
      setAllPromotions = _useState18[1];

  var _useState19 = (0,react.useState)(""),
      bannerData = _useState19[0],
      setBannerData = _useState19[1];

  var _useState20 = (0,react.useState)((0,helperServices/* getCurrentSortVal */.XH)(router.asPath, true)),
      sortProductsBy = _useState20[0],
      setSortProductsBy = _useState20[1];

  var _useState21 = (0,react.useState)("filter"),
      featureSelected = _useState21[0],
      setFeatureSelected = _useState21[1];

  var _useState22 = (0,react.useState)(false),
      filterWithSort = _useState22[0],
      setFilterWithSort = _useState22[1];

  var _useState23 = (0,react.useState)(),
      _currentPage = _useState23[0],
      setCurrentPage = _useState23[1];

  var _useState24 = (0,react.useState)(false),
      isPageUpdated = _useState24[0],
      setIsPageUpdated = _useState24[1];

  var _useState25 = (0,react.useState)(false),
      renderdEmpty = _useState25[0],
      setRenderdEmpty = _useState25[1];

  var _useState26 = (0,react.useState)(false),
      analytics = _useState26[0],
      setAnalytics = _useState26[1];

  var _useState27 = (0,react.useState)(),
      gridId = _useState27[0],
      setGridId = _useState27[1];

  var _useState28 = (0,react.useState)({}),
      categoryList = _useState28[0],
      setCategoryList = _useState28[1];

  var _useState29 = (0,react.useState)({
    once: [],
    monthly: []
  }),
      priceFilterData = _useState29[0],
      setPriceFilterData = _useState29[1];

  var _useState30 = (0,react.useState)({
    once: [],
    monthly: []
  }),
      missingPriceFilterData = _useState30[0],
      setMissingPriceFilterData = _useState30[1];

  var _useState31 = (0,react.useState)({
    once: 0,
    monthly: 0
  }),
      aggMaxPrice = _useState31[0],
      setAggMaxPrice = _useState31[1];

  var _useState32 = (0,react.useState)({
    once: 0,
    monthly: 0
  }),
      aggMinPrice = _useState32[0],
      setAggMinPrice = _useState32[1];

  var _useState33 = (0,react.useState)(null),
      attributeFlag = _useState33[0],
      setAttributeFlag = _useState33[1];

  var _useState34 = (0,react.useState)(false),
      showProduct = _useState34[0],
      setShowProducts = _useState34[1];

  var _useState35 = (0,react.useState)(),
      sections = _useState35[0],
      setSections = _useState35[1];

  var _useState36 = (0,react.useState)(),
      seoMetaData = _useState36[0],
      setSeoMetaData = _useState36[1];

  var _useState37 = (0,react.useState)({}),
      _priceObj = _useState37[0],
      setPriceObj = _useState37[1];

  var _useState38 = (0,react.useState)([]),
      affordablePriceRange = _useState38[0],
      setAffordablePriceRange = _useState38[1];

  var _useState39 = (0,react.useState)([]),
      missingAffordablePriceRange = _useState39[0],
      setMissingAffordablePriceRange = _useState39[1];

  var apiErrors = {
    isCategoryError: false,
    isProductError: false,
    isProductFetched: false,
    isBannerError: false,
    isBrandError: false
  };

  var _useState40 = (0,react.useState)(apiErrors),
      errorType = _useState40[0],
      setErrorType = _useState40[1];

  var env = (config_default()).env;
  var urlPrefix = (config_default()).envConfigs[env].shoppingUrlPrefix;

  var joinAllData = function joinAllData(array) {
    var newKeys = [].concat.apply([], array);
    var allkeys = newKeys.join(",");
    return allkeys;
  };

  var errorMessages = {
    heading: labels/* default.errorMessages.lbl_page_error */.Z.errorMessages.lbl_page_error,
    subHeading1: labels/* default.errorMessages.lbl_page_error_subheading1 */.Z.errorMessages.lbl_page_error_subheading1,
    subHeading2: labels/* default.errorMessages.lbl_page_error_subheading2 */.Z.errorMessages.lbl_page_error_subheading2
  };

  var getStatusFilter = function getStatusFilter(filter) {
    var disabled = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    return products_objectSpread(products_objectSpread({}, filter), {}, {
      disabled: disabled
    });
  };

  var initAggregations = /*#__PURE__*/function () {
    var _ref = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee() {
      var _priceFilterData$once;

      var _products$products, _products$products$ag, _products$products2, _products$products2$a, _products$products3, _products$products3$a, _products$products3$a2, _products$products4, _products$products4$a, _products$products4$a2, products, oncePriceAggregation, monthlyPriceAggregation, brandAggregation, promotionAggregation, _oncePriceAggregation, _monthlyPriceAggregat, _oncePriceAggregation2, _monthlyPriceAggregat2, onceValueRange, monthlyValueRange, onceMissingValueRange, monthlyMissingValueRange;

      return regenerator_default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!aggregationsLoaded.current) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              if (!((priceFilterData === null || priceFilterData === void 0 ? void 0 : (_priceFilterData$once = priceFilterData.once) === null || _priceFilterData$once === void 0 ? void 0 : _priceFilterData$once.length) == 0)) {
                _context.next = 13;
                break;
              }

              aggregationsLoaded.current = true;
              _context.next = 6;
              return (0,filterService/* getProductAggregations */._V)({});

            case 6:
              products = _context.sent;
              oncePriceAggregation = products === null || products === void 0 ? void 0 : (_products$products = products.products) === null || _products$products === void 0 ? void 0 : (_products$products$ag = _products$products.aggregations) === null || _products$products$ag === void 0 ? void 0 : _products$products$ag.find(function (agg) {
                return agg.attribute_code === "price";
              });
              monthlyPriceAggregation = products === null || products === void 0 ? void 0 : (_products$products2 = products.products) === null || _products$products2 === void 0 ? void 0 : (_products$products2$a = _products$products2.aggregations) === null || _products$products2$a === void 0 ? void 0 : _products$products2$a.find(function (agg) {
                return agg.attribute_code === "bundle_product_price" || agg.attribute_code === "bundle_product_price_bucket";
              });
              brandAggregation = products === null || products === void 0 ? void 0 : (_products$products3 = products.products) === null || _products$products3 === void 0 ? void 0 : (_products$products3$a = _products$products3.aggregations) === null || _products$products3$a === void 0 ? void 0 : (_products$products3$a2 = _products$products3$a.find(function (agg) {
                return agg.attribute_code === "manufacturer";
              })) === null || _products$products3$a2 === void 0 ? void 0 : _products$products3$a2.options;
              promotionAggregation = products === null || products === void 0 ? void 0 : (_products$products4 = products.products) === null || _products$products4 === void 0 ? void 0 : (_products$products4$a = _products$products4.aggregations) === null || _products$products4$a === void 0 ? void 0 : (_products$products4$a2 = _products$products4$a.find(function (agg) {
                return agg.attribute_code === "promotion_tag";
              })) === null || _products$products4$a2 === void 0 ? void 0 : _products$products4$a2.options;

              if (oncePriceAggregation && monthlyPriceAggregation) {
                onceValueRange = (0,priceFilterUtils/* getPriceFilterDataFromOptions */.kD)((_oncePriceAggregation = oncePriceAggregation === null || oncePriceAggregation === void 0 ? void 0 : oncePriceAggregation.options) !== null && _oncePriceAggregation !== void 0 ? _oncePriceAggregation : []);
                monthlyValueRange = (0,priceFilterUtils/* getPriceFilterDataFromOptions */.kD)((_monthlyPriceAggregat = monthlyPriceAggregation === null || monthlyPriceAggregation === void 0 ? void 0 : monthlyPriceAggregation.options) !== null && _monthlyPriceAggregat !== void 0 ? _monthlyPriceAggregat : []);
                onceMissingValueRange = (0,priceFilterUtils/* getNotAllowedRanges */.Lp)((_oncePriceAggregation2 = oncePriceAggregation === null || oncePriceAggregation === void 0 ? void 0 : oncePriceAggregation.options) !== null && _oncePriceAggregation2 !== void 0 ? _oncePriceAggregation2 : []);
                monthlyMissingValueRange = (0,priceFilterUtils/* getNotAllowedRanges */.Lp)((_monthlyPriceAggregat2 = monthlyPriceAggregation === null || monthlyPriceAggregation === void 0 ? void 0 : monthlyPriceAggregation.options) !== null && _monthlyPriceAggregat2 !== void 0 ? _monthlyPriceAggregat2 : []);
                setAggMaxPrice({
                  once: onceValueRange[(onceValueRange === null || onceValueRange === void 0 ? void 0 : onceValueRange.length) - 1] || constants/* MAX_ONCE_OF */.X_,
                  monthly: monthlyValueRange[(monthlyValueRange === null || monthlyValueRange === void 0 ? void 0 : monthlyValueRange.length) - 1] || constants/* MAX_MONTHLY_RECURRING */._V
                });
                setAggMinPrice({
                  once: onceValueRange[0] || 0,
                  monthly: monthlyValueRange[0] || 0
                });
                setPriceFilterData({
                  once: onceValueRange,
                  monthly: monthlyValueRange
                });
                setMissingPriceFilterData({
                  once: onceMissingValueRange,
                  monthly: monthlyMissingValueRange
                });
              }

              updateFilters({
                brandAggregation: brandAggregation,
                promotionAggregation: promotionAggregation
              });

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function initAggregations() {
      return _ref.apply(this, arguments);
    };
  }();

  var updateFilters = function updateFilters(_ref2) {
    var _ref2$brandAggregatio = _ref2.brandAggregation,
        brandAggregation = _ref2$brandAggregatio === void 0 ? [] : _ref2$brandAggregatio,
        _ref2$promotionAggreg = _ref2.promotionAggregation,
        promotionAggregation = _ref2$promotionAggreg === void 0 ? [] : _ref2$promotionAggreg;

    if (brandAggregation !== null && brandAggregation !== void 0 && brandAggregation.length) {
      if (allBrands.length) {
        setAllBrands(allBrands.map(function (brand) {
          if (brandAggregation.findIndex(function (newBrand) {
            return newBrand.value === brand.value;
          }) > -1) {
            return products_objectSpread(products_objectSpread({}, brand), {}, {
              disabled: false
            });
          } else {
            return products_objectSpread(products_objectSpread({}, brand), {}, {
              disabled: true
            });
          }
        }));
      } else {
        setAllBrands(brandAggregation === null || brandAggregation === void 0 ? void 0 : brandAggregation.map(function (brand) {
          return getStatusFilter(brand);
        }));
      }
    } else {
      if (allBrands.length) {
        setAllBrands(allBrands === null || allBrands === void 0 ? void 0 : allBrands.map(function (brand) {
          return getStatusFilter(brand, true);
        }));
      } else {
        errorType.isBrandError = true;
        setErrorType(errorType);
      }
    }

    if (promotionAggregation !== null && promotionAggregation !== void 0 && promotionAggregation.length) {
      if (allPromotions.length) {
        setAllPromotions(allPromotions.map(function (promotion) {
          if (promotionAggregation.findIndex(function (newPromotion) {
            return newPromotion.value === promotion.value;
          }) > -1) {
            return products_objectSpread(products_objectSpread({}, promotion), {}, {
              disabled: false
            });
          } else {
            return products_objectSpread(products_objectSpread({}, promotion), {}, {
              disabled: true
            });
          }
        }));
      } else {
        setAllPromotions(promotionAggregation === null || promotionAggregation === void 0 ? void 0 : promotionAggregation.map(function (promotion) {
          return getStatusFilter(promotion);
        }));
      }
    } else {
      setAllPromotions(allPromotions === null || allPromotions === void 0 ? void 0 : allPromotions.map(function (promotion) {
        return getStatusFilter(promotion, true);
      }));
    }
  };

  var updateAggregations = /*#__PURE__*/function () {
    var _ref4 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee2(_ref3) {
      var minPrice, maxPrice, type, endType, _products$products5, _products$products5$a, _products$products5$a2, _products$products6, _products$products6$a, _products$products6$a2, products, brandAggregation, promotionAggregation;

      return regenerator_default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              minPrice = _ref3.minPrice, maxPrice = _ref3.maxPrice, type = _ref3.type, endType = _ref3.endType;

              if (!(maxPrice || endType == "range")) {
                _context2.next = 8;
                break;
              }

              _context2.next = 4;
              return (0,filterService/* getProductAggregations */._V)({
                selectedFilter: selectedFilter,
                maxPrice: maxPrice,
                type: type,
                minPrice: minPrice
              });

            case 4:
              products = _context2.sent;
              brandAggregation = products === null || products === void 0 ? void 0 : (_products$products5 = products.products) === null || _products$products5 === void 0 ? void 0 : (_products$products5$a = _products$products5.aggregations) === null || _products$products5$a === void 0 ? void 0 : (_products$products5$a2 = _products$products5$a.find(function (agg) {
                return agg.attribute_code === "manufacturer";
              })) === null || _products$products5$a2 === void 0 ? void 0 : _products$products5$a2.options;
              promotionAggregation = products === null || products === void 0 ? void 0 : (_products$products6 = products.products) === null || _products$products6 === void 0 ? void 0 : (_products$products6$a = _products$products6.aggregations) === null || _products$products6$a === void 0 ? void 0 : (_products$products6$a2 = _products$products6$a.find(function (agg) {
                return agg.attribute_code === "promotion_tag";
              })) === null || _products$products6$a2 === void 0 ? void 0 : _products$products6$a2.options;
              updateFilters({
                brandAggregation: brandAggregation,
                promotionAggregation: promotionAggregation
              });

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function updateAggregations(_x) {
      return _ref4.apply(this, arguments);
    };
  }();

  var initAggregationsMaxPrice = /*#__PURE__*/function () {
    var _ref5 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee3(maxPriceValue, type) {
      var _products$products7, _products$products7$a, _products$products8, _products$products8$a, _products$products8$a2, _products$products9, _products$products9$a, _products$products9$a2, products, monthlyPriceAggregation, brandAggregation, promotionAggregation, _monthlyPriceAggregat3, _monthlyPriceAggregat4, monthlyValueRange, monthlyMissingValueRange, affordablePriceFilterData;

      return regenerator_default().wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              if (!maxPriceValue) {
                _context3.next = 9;
                break;
              }

              _context3.next = 3;
              return (0,filterService/* getProductAggregations */._V)({
                selectedFilter: selectedFilter,
                maxPrice: maxPriceValue,
                type: type
              });

            case 3:
              products = _context3.sent;
              monthlyPriceAggregation = products === null || products === void 0 ? void 0 : (_products$products7 = products.products) === null || _products$products7 === void 0 ? void 0 : (_products$products7$a = _products$products7.aggregations) === null || _products$products7$a === void 0 ? void 0 : _products$products7$a.find(function (agg) {
                return agg.attribute_code === "bundle_product_price" || "bundle_product_price_bucket";
              });
              brandAggregation = products === null || products === void 0 ? void 0 : (_products$products8 = products.products) === null || _products$products8 === void 0 ? void 0 : (_products$products8$a = _products$products8.aggregations) === null || _products$products8$a === void 0 ? void 0 : (_products$products8$a2 = _products$products8$a.find(function (agg) {
                return agg.attribute_code === "manufacturer";
              })) === null || _products$products8$a2 === void 0 ? void 0 : _products$products8$a2.options;
              promotionAggregation = products === null || products === void 0 ? void 0 : (_products$products9 = products.products) === null || _products$products9 === void 0 ? void 0 : (_products$products9$a = _products$products9.aggregations) === null || _products$products9$a === void 0 ? void 0 : (_products$products9$a2 = _products$products9$a.find(function (agg) {
                return agg.attribute_code === "promotion_tag";
              })) === null || _products$products9$a2 === void 0 ? void 0 : _products$products9$a2.options;

              if (monthlyPriceAggregation) {
                monthlyValueRange = (0,priceFilterUtils/* getPriceFilterDataFromOptions */.kD)((_monthlyPriceAggregat3 = monthlyPriceAggregation === null || monthlyPriceAggregation === void 0 ? void 0 : monthlyPriceAggregation.options) !== null && _monthlyPriceAggregat3 !== void 0 ? _monthlyPriceAggregat3 : []);
                monthlyMissingValueRange = (0,priceFilterUtils/* getNotAllowedRanges */.Lp)((_monthlyPriceAggregat4 = monthlyPriceAggregation === null || monthlyPriceAggregation === void 0 ? void 0 : monthlyPriceAggregation.options) !== null && _monthlyPriceAggregat4 !== void 0 ? _monthlyPriceAggregat4 : []);
                affordablePriceFilterData = (0,priceFilterUtils/* getAffordablePriceFilterDataFromOptions */.b0)(monthlyValueRange, Number(maxPriceValue), aggMaxPrice.monthly);
                setAffordablePriceRange(affordablePriceFilterData);
                setMissingAffordablePriceRange(monthlyMissingValueRange);
              }

              updateFilters({
                brandAggregation: brandAggregation,
                promotionAggregation: promotionAggregation
              });

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function initAggregationsMaxPrice(_x2, _x3) {
      return _ref5.apply(this, arguments);
    };
  }();

  var reloadPageData = function reloadPageData() {
    (0,helperServices/* showSpinner */.yh)();
    setIsPageUpdated(true);
  };

  var isMonthly = function isMonthly() {
    return priceType === types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY;
  };

  var isOnceOff = function isOnceOff() {
    return !priceType || priceType === types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF;
  };

  var setMaxMonthlyPrice = function setMaxMonthlyPrice(value) {
    _setPriceValue({
      minValue: aggMinPrice.monthly,
      maxValue: value
    });

    setMaxPrice(value);
  };

  var switchPriceToOnceOff = function switchPriceToOnceOff() {
    _setPriceType(types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF);

    _setPriceValue({
      minValue: aggMinPrice.once,
      maxValue: aggMaxPrice.once
    });

    setMaxPrice(aggMaxPrice.once);
  };

  var switchPriceToMonthly = function switchPriceToMonthly() {
    _setPriceType(types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);

    _setPriceValue({
      minValue: aggMinPrice.monthly,
      maxValue: aggMaxPrice.monthly
    });

    setMaxPrice(aggMaxPrice.monthly);
  };

  var handlePriceTypeChange = function handlePriceTypeChange(type) {
    var _getPriceType = getPriceType(type),
        maxValue = _getPriceType.maxValue,
        minValue = _getPriceType.minValue;

    (0,filterService/* getProductsFilterByPrice */.XD)({
      minValue: minValue,
      maxValue: maxValue,
      type: type,
      isShowQualifying: "false",
      skipPageNumber: true
    }).then(reloadPageData);
  };

  var getPriceType = function getPriceType(type) {
    var maxValue;
    var minValue;

    if (type === types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY) {
      switchPriceToMonthly();
      minValue = aggMinPrice.monthly;
      maxValue = aggMaxPrice.monthly;
    } else {
      switchPriceToOnceOff();
      minValue = aggMinPrice.once;
      maxValue = aggMaxPrice.once;
    }

    setShowQualifyProducts(false);
    return {
      maxValue: maxValue,
      minValue: minValue
    };
  };

  var handlePriceChange = function handlePriceChange(value, priceType) {
    getSelectedPrice(value, priceType);
    (0,filterService/* getProductsFilterByPrice */.XD)({
      minValue: value.min,
      maxValue: value.max,
      type: priceType,
      isShowQualifying: showQualifyProducts ? "true" : "false"
    }).then(reloadPageData);
  };

  var getSelectedPrice = function getSelectedPrice(value, priceType) {
    if (priceType) {
      _setPriceType(priceType);
    } else {
      priceType = maxMonthlyPrice < aggMaxPrice.monthly ? types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY : types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF;

      _setPriceType(priceType);
    }

    _setPriceValue({
      minValue: value.min,
      maxValue: value.max
    });

    setPriceObj({
      type: priceType,
      min: value.min,
      max: value.max
    });
    (0,analyticsUtag/* link */.p4)(products_objectSpread(products_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)()), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: product grid: price filter",
      filter_query: "".concat(priceType, ",").concat(value.min || 0, ",").concat(value.max || 100000),
      page_name: "shopping: devices: product grid",
      page_channel: "shopping"
    }));
  };

  var handleBrandChange = function handleBrandChange(flag, value) {
    var brandArr = getSelectedBrands(flag, value);
    (0,filterService/* getProductsFilterByBrands */.Gh)(brandArr).then(reloadPageData);
  };

  var getSelectedBrands = function getSelectedBrands(flag, value) {
    var _selectedFilter, _selectedFilter2;

    var brandArr = (_selectedFilter = selectedFilter) !== null && _selectedFilter !== void 0 && _selectedFilter.brands ? (0,toConsumableArray/* default */.Z)((_selectedFilter2 = selectedFilter) === null || _selectedFilter2 === void 0 ? void 0 : _selectedFilter2.brands) : [];

    if (flag) {
      brandArr.filter(function (brand) {
        return brand.label === value.label;
      }).length === 0 ? brandArr.push(value) : brandArr;
    } else {
      brandArr.filter(function (brand, index) {
        if (brand.label === value.label) {
          brandArr.splice(index, 1);
        }
      });
    }

    setSelectedFilter(products_objectSpread(products_objectSpread({}, selectedFilter), {
      brands: brandArr
    }));
    var selectedBrands = brandArr.map(function (brand) {
      return brand.label;
    });
    (0,analyticsUtag/* link */.p4)(products_objectSpread(products_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)()), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: product grid: brand filter",
      filter_query: selectedBrands.toString(),
      page_name: "shopping: devices: product grid",
      page_channel: "shopping"
    }));
    return brandArr;
  };

  var handlePromotionChange = function handlePromotionChange(flag, value) {
    var promotionArr = getSelectedPromotion(flag, value);
    (0,filterService/* getProductsFilterByPromotions */.QF)(promotionArr).then(reloadPageData);
  };

  var getSelectedPromotion = function getSelectedPromotion(flag, value) {
    var _selectedFilter3, _selectedFilter4;

    var promotionArr = (_selectedFilter3 = selectedFilter) !== null && _selectedFilter3 !== void 0 && _selectedFilter3.promotions ? (0,toConsumableArray/* default */.Z)((_selectedFilter4 = selectedFilter) === null || _selectedFilter4 === void 0 ? void 0 : _selectedFilter4.promotions) : [];

    if (flag) {
      promotionArr.filter(function (promotion) {
        return promotion.label === value.label;
      }).length === 0 ? promotionArr.push(value) : promotionArr;
    } else {
      promotionArr.filter(function (promotion, index) {
        if (promotion.label === value.label) {
          promotionArr.splice(index, 1);
        }
      });
    }

    setSelectedFilter(products_objectSpread(products_objectSpread({}, selectedFilter), {
      promotions: promotionArr
    }));
    (0,analyticsUtag/* link */.p4)(products_objectSpread(products_objectSpread({}, (0,analyticsUtag/* getUtagData */.GS)()), {}, {
      page_tool_event: "use",
      page_tool_name: "shopping: product grid: promotions filter",
      filter_query: value.label,
      page_name: "shopping: devices: product grid",
      page_channel: "shopping"
    }));
    return promotionArr;
  };

  var handleSelectedCategory = function handleSelectedCategory(categoryId) {
    var tempSelectedFilter = products_objectSpread({}, selectedFilter);

    for (var key in tempSelectedFilter) {
      if (key != "updateFilterCriteria" && key != "isShowQualifying" && key != "monthlyPrice") {
        delete tempSelectedFilter[key];
      }
    }

    if (!categoryId) {
      setSelectedFilter.apply(void 0, (0,toConsumableArray/* default */.Z)(tempSelectedFilter));
    } else {
      setSelectedFilter(products_objectSpread(products_objectSpread({}, tempSelectedFilter), {
        selectedCategory: categoryId
      }));
    }
  };

  var handleApplyFilter = function handleApplyFilter() {
    var newSelectedFilters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : selectedFilter || {};
    var brands = newSelectedFilters.brands,
        promotions = newSelectedFilters.promotions,
        selectedCategory = newSelectedFilters.selectedCategory,
        selectedSubCategory = newSelectedFilters.selectedSubCategory;

    var _ref6 = priceValue || {},
        minValue = _ref6.minValue,
        maxValue = _ref6.maxValue;

    var filterHref = "";
    var str = "";

    if (selectedCategory) {
      str = (0,filterService/* getProductsFilterByCategory */.hH)(selectedCategory, true); //true-return href, false-router push

      if (str && str !== "") {
        filterHref += str;
      }
    }

    if (selectedSubCategory) {
      str = (0,filterService/* getProductsFilterBySubCategory */.wK)(selectedSubCategory, true); //true-return href, false-router push

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (brands) {
      str = (0,filterService/* getProductsFilterByBrands */.Gh)(brands, true); //true-return href, false-router push

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (promotions) {
      str = (0,filterService/* getProductsFilterByPromotions */.QF)(promotions, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (Object.keys(priceValue).length !== 0) {
      var priceObj = {
        type: priceType || types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF,
        minValue: minValue,
        maxValue: maxValue,
        isShowQualifying: showQualifyProducts,
        skipPageNumber: true
      };
      str = (0,filterService/* getProductsFilterByPrice */.XD)(priceObj, true);

      if (str && str !== "") {
        filterHref += filterHref == "" ? str : "&".concat(str);
      }
    }

    if (filterHref !== "") {
      var newHref = filterHref ? "".concat(urlPrefix, "/products?").concat(filterHref) : "".concat(urlPrefix, "/products");
      DependencyHelper.Router.push("".concat(urlPrefix, "/products"), newHref, {
        shallow: true
      }).then(reloadPageData);
    }
  };

  var isEligible = function isEligible() {
    var _props$upgrade, _props$upgrade2, _props$upgrade2$upgra;

    return (props === null || props === void 0 ? void 0 : (_props$upgrade = props.upgrade) === null || _props$upgrade === void 0 ? void 0 : _props$upgrade.upgradeCheckDone) && (props === null || props === void 0 ? void 0 : (_props$upgrade2 = props.upgrade) === null || _props$upgrade2 === void 0 ? void 0 : (_props$upgrade2$upgra = _props$upgrade2.upgradeResponse) === null || _props$upgrade2$upgra === void 0 ? void 0 : _props$upgrade2$upgra.upgradeEligible);
  };

  var handleResetFilter = function handleResetFilter(type, fullReset) {
    if (fullReset) {
      /* filter full reset */
      if (isEligible()) {
        /* if upgrade in progress */
        setMaxMonthlyPrice(getMaxPrice());
        setShowQualifyProducts(true);

        _setPriceType(types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);

        return (0,filterService/* resetToPrice */.qU)("monthlyPrice", aggMinPrice.monthly, getMaxPrice(), router).then(reloadPageData);
      }
      /* default case */


      switchPriceToOnceOff();

      _setPriceType("");

      return (0,filterService/* resetMobileFilter */.XU)().then(reloadPageData);
    }

    if (type === "price") {
      /* price filter reset */
      if (isEligible()) {
        /* if upgrade in progress */
        var eliMaxPrice = getMaxPrice();
        setMaxMonthlyPrice(eliMaxPrice);
        setShowQualifyProducts(true);

        _setPriceType(types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);

        return (0,filterService/* getProductsFilterByPrice */.XD)({
          minValue: aggMinPrice.monthly,
          maxValue: eliMaxPrice,
          // FIXED.MAX_MONTHLY_RECURRING,
          type: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
          isShowQualifying: "true"
        }).then(reloadPageData);
      }

      setPriceReset(true);
      switchPriceToOnceOff();
      var dataType = priceType === types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY ? "monthlyPrice" : "price";

      _setPriceType("");

      (0,filterService/* resetData */.uY)(dataType, selectedFilter, router).then(reloadPageData);
    }
  };

  var getBannerAttributesForCategory = /*#__PURE__*/function () {
    var _ref7 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee4() {
      return regenerator_default().wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              setGridId(props.id);

            case 1:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    return function getBannerAttributesForCategory() {
      return _ref7.apply(this, arguments);
    };
  }();

  var getPromotionData = /*#__PURE__*/function () {
    var _ref8 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee5() {
      var promotionData;
      return regenerator_default().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return pageService/* getPageComponents */.eU(["products/CBU".concat(props !== null && props !== void 0 && props.previewMode ? (config_default()).pageServiceQueryData.preview : (config_default()).pageServiceQueryData.status)]);

            case 2:
              promotionData = _context5.sent;
              setSections((promotionData === null || promotionData === void 0 ? void 0 : promotionData.sections) || []);
              setSeoMetaData((promotionData === null || promotionData === void 0 ? void 0 : promotionData.seoMetadata) || {});

              if (promotionData && promotionData.status === "error") {
                (0,analyticsUtag/* link */.p4)({
                  page_name: pageName,
                  page_form_event: "error",
                  page_errors: "".concat(promotionData.reason ? promotionData.reason : ""),
                  page_errors_code: "plp-d-g-seo"
                });
              }

            case 6:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    return function getPromotionData() {
      return _ref8.apply(this, arguments);
    };
  }();

  var getCategoryGridData = /*#__PURE__*/function () {
    var _ref9 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee6() {
      var _categoryList$categor, _categoryList, _categoryList$errors;

      return regenerator_default().wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 3;
              return (0,productListService/* getAllCategories */.tG)(false, props === null || props === void 0 ? void 0 : props.defaultCategoryId, props === null || props === void 0 ? void 0 : props.dealCategoryId);

            case 3:
              _categoryList = _context6.sent;

              if (_categoryList && ((_categoryList$categor = _categoryList.categories) === null || _categoryList$categor === void 0 ? void 0 : _categoryList$categor.length) === 0) {
                errorType.isCategoryError = true;
                setErrorType(errorType);
              } else {
                setCategoryList(_categoryList);
                errorType.isCategoryError = false;
                setErrorType(errorType);
                setShowProducts(true);
              }

              if (_categoryList && _categoryList.errors) {
                (0,analyticsUtag/* link */.p4)({
                  page_name: pageName,
                  page_form_event: "error",
                  page_errors: "".concat(_categoryList.errors[0] ? (_categoryList$errors = _categoryList.errors) === null || _categoryList$errors === void 0 ? void 0 : _categoryList$errors[0].message : ""),
                  page_errors_code: "plp-dxl-g-ac-".concat(_categoryList.status)
                });
              }

              _context6.next = 12;
              break;

            case 8:
              _context6.prev = 8;
              _context6.t0 = _context6["catch"](0);
              errorType.isCategoryError = true;
              setErrorType(errorType);

            case 12:
              _context6.prev = 12;
              (0,helperServices/* hideSpinner */.v3)();
              return _context6.finish(12);

            case 15:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[0, 8, 12, 15]]);
    }));

    return function getCategoryGridData() {
      return _ref9.apply(this, arguments);
    };
  }();

  var isFilterApplied = /*#__PURE__*/function () {
    var _ref10 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee7(sortParam) {
      var _props$upgrade3, _props$upgrade3$credi, filter, _props$upgrade4, _props$upgrade4$credi, _ref11, minValue, maxValue, _priceType, _selectedFilter7, _selectedFilter8, _selectedFilter5, _selectedFilter6, _ref12, _minValue, _maxValue, _productList$errors, _productList$errors2;

      return regenerator_default().wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              (0,helperServices/* showSpinner */.yh)();
              setShowProducts(false);
              _context7.prev = 2;
              _context7.next = 5;
              return (0,filterService/* parseFilterQuery */.w6)(decodeURIComponent(window.location.search));

            case 5:
              filter = _context7.sent;

              if (showQualifyProducts && (props === null || props === void 0 ? void 0 : (_props$upgrade3 = props.upgrade) === null || _props$upgrade3 === void 0 ? void 0 : (_props$upgrade3$credi = _props$upgrade3.creditFilters) === null || _props$upgrade3$credi === void 0 ? void 0 : _props$upgrade3$credi.financeIndicator) === "N") {
                filter.deviceInstallment = Number(props === null || props === void 0 ? void 0 : (_props$upgrade4 = props.upgrade) === null || _props$upgrade4 === void 0 ? void 0 : (_props$upgrade4$credi = _props$upgrade4.creditFilters) === null || _props$upgrade4$credi === void 0 ? void 0 : _props$upgrade4$credi.deviceInstallment);
              }

              if (filter !== null && filter !== void 0 && filter.monthlyPrice || filter !== null && filter !== void 0 && filter.price) {
                _ref11 = (filter === null || filter === void 0 ? void 0 : filter.price) || (filter === null || filter === void 0 ? void 0 : filter.monthlyPrice), minValue = _ref11.minValue, maxValue = _ref11.maxValue;

                _setPriceValue({
                  minValue: minValue && Number(minValue) || 0,
                  maxValue: Number(maxValue)
                });

                _priceType = filter !== null && filter !== void 0 && filter.monthlyPrice ? types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY : types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF;

                _setPriceType(_priceType);
              } else {
                _setPriceType("");
              }

              if (JSON.stringify(filter) != JSON.stringify(selectedFilter) || filterWithSort || isPageUpdated) {
                productListLoaded.current = false;
                setSelectedFilter(selectedFilter = filter);

                if (!(filter !== null && filter !== void 0 && filter.monthlyPrice) && !(filter !== null && filter !== void 0 && filter.price)) {
                  setPriceObj({});
                }

                if (!isEligible() && (filter !== null && filter !== void 0 && filter.monthlyPrice || filter !== null && filter !== void 0 && filter.price)) {
                  _ref12 = (filter === null || filter === void 0 ? void 0 : filter.price) || (filter === null || filter === void 0 ? void 0 : filter.monthlyPrice), _minValue = _ref12.minValue, _maxValue = _ref12.maxValue;

                  _setPriceValue({
                    minValue: _minValue && Number(_minValue) || 0,
                    maxValue: Number(_maxValue)
                  });

                  if ((_selectedFilter5 = selectedFilter) !== null && _selectedFilter5 !== void 0 && _selectedFilter5.monthlyPrice) {
                    _setPriceType(types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);

                    setMaxPrice(aggMaxPrice.monthly);
                  }

                  if ((_selectedFilter6 = selectedFilter) !== null && _selectedFilter6 !== void 0 && _selectedFilter6.price) {
                    if (!priceReset) _setPriceType(types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF);else _setPriceType("");
                    setMaxPrice(aggMaxPrice.once);
                  }
                }

                if (!isEligible() && !((_selectedFilter7 = selectedFilter) !== null && _selectedFilter7 !== void 0 && _selectedFilter7.monthlyPrice || (_selectedFilter8 = selectedFilter) !== null && _selectedFilter8 !== void 0 && _selectedFilter8.price)) {
                  setMaxMonthlyPrice(aggMaxPrice.once);
                }

                setPriceReset(false);
              }

              if (!(selectedFilter && typeof selectedFilter === 'object' && Object.keys(selectedFilter) && !productListLoaded.current)) {
                _context7.next = 18;
                break;
              }

              productListLoaded.current = true;
              _context7.next = 13;
              return (0,filterService/* getFilterProductList */.tA)(filter, sortParam, (0,helperServices/* getCurrentPageNumber */.GW)(router.asPath));

            case 13:
              productList = _context7.sent;
              setProductList(productList ? productList : {});

              if (productList && productList.errors) {
                (0,analyticsUtag/* link */.p4)({
                  page_name: pageName,
                  page_form_event: "error",
                  page_errors: "".concat(productList.errors[0] ? (_productList$errors = productList.errors) === null || _productList$errors === void 0 ? void 0 : _productList$errors[0].message : ""),
                  page_errors_code: "plp-m-g-fp-".concat(productList.status)
                });
              }

              _context7.next = 24;
              break;

            case 18:
              productListLoaded.current = true;
              _context7.next = 21;
              return (0,filterService/* getProductList */.jw)(filter, sortParam, (0,helperServices/* getCurrentPageNumber */.GW)(router.asPath));

            case 21:
              productList = _context7.sent;
              setProductList(productList ? productList : {});

              if (productList && productList.errors) {
                (0,analyticsUtag/* link */.p4)({
                  page_name: pageName,
                  page_form_event: "error",
                  page_errors: "".concat(productList.errors[0] ? (_productList$errors2 = productList.errors) === null || _productList$errors2 === void 0 ? void 0 : _productList$errors2[0].message : ""),
                  page_errors_code: "plp-m-g-p-".concat(productList.status)
                });
              }

            case 24:
              setFilterWithSort(false);
              _context7.next = 27;
              return getPromotionData();

            case 27:
              errorType.isProductError = productList && productList.products ? false : true;
              errorType.isProductFetched = productList && productList.products ? true : false;
              setErrorType(errorType);
              _context7.next = 36;
              break;

            case 32:
              _context7.prev = 32;
              _context7.t0 = _context7["catch"](2);
              errorType.isProductError = true;
              setErrorType(errorType);

            case 36:
              _context7.prev = 36;

              if (!(attributeFlag === null || attributeFlag !== true)) {
                _context7.next = 41;
                break;
              }

              _context7.next = 40;
              return getBannerAttributesForCategory();

            case 40:
              setAttributeFlag(true);

            case 41:
              if (!(Object.keys(categoryList).length === 0 || errorType.isCategoryError)) {
                _context7.next = 44;
                break;
              }

              _context7.next = 44;
              return getCategoryGridData();

            case 44:
              errorType.isProductFetched = true;
              setErrorType(errorType);
              setShowProducts(true);
              (0,helperServices/* hideSpinner */.v3)();
              return _context7.finish(36);

            case 49:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[2, 32, 36, 49]]);
    }));

    return function isFilterApplied(_x4) {
      return _ref10.apply(this, arguments);
    };
  }();

  var loadProducts = function loadProducts() {
    (0,helperServices/* showSpinner */.yh)();
    setIsPageUpdated(false);
    var sortFromRoute = (0,helperServices/* getCurrentSortVal */.XH)(router.asPath, true);
    var sortParam = (0,filterService/* getSortQuery */.yU)(sortFromRoute);
    setSortProductsBy(sortFromRoute);
    (0,helperServices/* updatePathInBreadCrumb */.DQ)(router);
    isFilterApplied(sortParam);
  };

  (0,react.useEffect)(function () {
    loadProducts();
  }, [router.query, router.pathname]);
  (0,react.useEffect)(function () {
    initAggregations();
    dispatch({
      type: actionTypes/* ALERT_SELECT */.XI,
      payload: false
    });
    (0,analyticsUtag/* setAutoTagging */.fv)(false);
    window.scrollTo(0, 0);
  }, []);
  (0,react.useEffect)(function () {
    props.toggleFilters(false);
  }, []);
  (0,react.useEffect)(function () {
    if (showProduct) {
      setErrorType(errorType);
    }
  }, [showProduct]);
  (0,react.useEffect)(function () {
    var _selectedFilter9, _selectedFilter9$prom, _selectedFilter10, _selectedFilter10$bra;

    var selectedPromotionsData = ((_selectedFilter9 = selectedFilter) === null || _selectedFilter9 === void 0 ? void 0 : (_selectedFilter9$prom = _selectedFilter9.promotions) === null || _selectedFilter9$prom === void 0 ? void 0 : _selectedFilter9$prom.map(function (item) {
      return item.value;
    })) || [];
    var selectedBrandsData = ((_selectedFilter10 = selectedFilter) === null || _selectedFilter10 === void 0 ? void 0 : (_selectedFilter10$bra = _selectedFilter10.brands) === null || _selectedFilter10$bra === void 0 ? void 0 : _selectedFilter10$bra.map(function (item) {
      return item.value;
    })) || [];

    function getBannerData() {
      return _getBannerData.apply(this, arguments);
    }

    function _getBannerData() {
      _getBannerData = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee8() {
        var bannerResult, _bannerResult$errors;

        return regenerator_default().wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return ajaxServices/* default.fetchGraphQLGetRequest */.Z.fetchGraphQLGetRequest(queries/* BannerDetails */.zH, {
                  grid: gridId,
                  brand: "".concat(joinAllData(selectedBrandsData)),
                  promotion: "".concat(joinAllData(selectedPromotionsData))
                });

              case 2:
                bannerResult = _context8.sent;

                if (bannerResult) {
                  setBannerData((bannerResult === null || bannerResult === void 0 ? void 0 : bannerResult.banners) || []);

                  if (bannerResult.errors) {
                    (0,analyticsUtag/* link */.p4)({
                      page_name: pageName,
                      page_form_event: "error",
                      page_errors: "".concat(bannerResult.errors[0] ? (_bannerResult$errors = bannerResult.errors) === null || _bannerResult$errors === void 0 ? void 0 : _bannerResult$errors[0].message : ""),
                      page_errors_code: "dlp-m-g-bd-".concat(bannerResult.status)
                    });
                  }
                }

              case 4:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));
      return _getBannerData.apply(this, arguments);
    }

    if (gridId) {
      if ((selectedBrandsData === null || selectedBrandsData === void 0 ? void 0 : selectedBrandsData.length) > 1) {
        setBannerData([]);
      } else {
        getBannerData();
      }
    }
  }, [(_selectedFilter11 = selectedFilter) === null || _selectedFilter11 === void 0 ? void 0 : _selectedFilter11.promotions, (_selectedFilter12 = selectedFilter) === null || _selectedFilter12 === void 0 ? void 0 : _selectedFilter12.brands, gridId]);

  var toggleHandler = function toggleHandler(btnClicked) {
    setFeatureSelected(btnClicked);
    setshowComp(!showComp);
    props.toggleFilters(true);
  };

  var changeState = function changeState() {
    setshowComp(!showComp);
  };

  var breadcrumbs = (0,breadcrumbService/* breadcrumbGenerator */.G)().productlist.reverse();
  (0,react.useEffect)(function () {
    if (Object.keys(dynamicRoute).length && !viewExecuted && !props.profileLoading) {
      if (!analytics) {
        var section_lvls = {};
        var index = 0;

        var _iterator = products_createForOfIteratorHelper(breadcrumbs),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            index = index + 1;
            if (index > 4) break;
            section_lvls["page_site_section_lvl_".concat(index)] = item.label;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }

        var userMetaData = (0,analyticsUtag/* getProfileData */.$y)(props.userLoggedIn, props.profileData);
        (0,analyticsUtag/* view */.ei)(products_objectSpread(products_objectSpread({
          page_event: "view",
          page_name: pageName,
          page_channel: "shopping",
          channel_type: "Monthly",
          page_master_tab: "personal"
        }, section_lvls), userMetaData));
        setViewExecuted(true);
        setSectionLvls(section_lvls);
        setAnalytics(true);
      }
    }
  }, [dynamicRoute, props.profileLoading, props.userLoggedIn, props.profileData]);
  (0,react.useEffect)(function () {
    if (productList && productList.products && productList.products.items && productList.products.items.length > 0) {
      setRenderdEmpty(false);
    } else {
      if (!renderdEmpty && productList && productList.products && productList.products.total_count == 0) {
        (0,analyticsUtag/* link */.p4)(products_objectSpread({
          page_name: pageName,
          page_form_event: "error",
          page_errors: "We couldn't find any results for your selected filters. Try widen your search by changing some of your selections, or reset all filters below.",
          page_channel: "shopping",
          page_master_tab: "personal"
        }, sectionLvls));
        setRenderdEmpty(true);
      }
    }
  }, [(_productList = productList) === null || _productList === void 0 ? void 0 : _productList.products]);

  var sortBy = /*#__PURE__*/function () {
    var _ref13 = (0,asyncToGenerator/* default */.Z)( /*#__PURE__*/regenerator_default().mark(function _callee9(val) {
      return regenerator_default().wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              setSortProductsBy(val);
              setFilterWithSort(true);
              (0,filterService/* getProductsFilterBySort */.bq)(val).then(reloadPageData);

            case 3:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    return function sortBy(_x5) {
      return _ref13.apply(this, arguments);
    };
  }();

  var updateCurrentPage = function updateCurrentPage(page) {
    (0,filterService/* getProductsFilterByPageNumber */.Zu)(page).then(function () {
      setSelectedFilter(products_objectSpread(products_objectSpread({}, selectedFilter), {
        currentPage: page
      }));
      setCurrentPage(page);
      reloadPageData();
      scrollTo(0, 0);
    });
  };

  var filteredCategory = (0,filterService/* getFilteredCategory */.WV)(selectedFilter, categoryList);
  var filteredCategories = (0,filterService/* getFilteredCategories */.RB)(selectedFilter, categoryList);
  (0,react.useEffect)(function () {
    if (isPageUpdated) {
      loadProducts(); //This will create the ListPageRouterWithFilters session variable
      //that will be used by pages such as shopping/product-compare for redirection

      var temparray = [{
        products: decodeURI(router.asPath)
      }];
      (0,helperServices/* updateSessionStorage */.F$)(labels/* default.Session_Keys.lbl_list_page_router_with_filters */.Z.Session_Keys.lbl_list_page_router_with_filters, temparray);
      setTimeout(lib/* forceVisible */.Iq, 1000);
    }
  }, [isPageUpdated]);

  var handleRangeChange = function handleRangeChange(val) {
    var curRange = Number(val);
    var total = categoryList.categories ? categoryList.categories.length : 0;

    for (var i = 0; i < total; i++) {
      if (curRange === Number(categoryList.categories[i].id)) {
        var _selectedCategory;

        if (Number((_selectedCategory = selectedCategory) === null || _selectedCategory === void 0 ? void 0 : _selectedCategory.id) === curRange) {
          curRange = null;
        }

        (0,analyticsUtag/* link */.p4)(products_objectSpread(products_objectSpread({
          page_tool_event: "use",
          page_tool_name: "shopping: product grid: product range filter",
          page_name: pageName,
          filter_query: "".concat(categoryList.categories[i].name)
        }, sectionLvls), (0,analyticsUtag/* getUtagData */.GS)(["page_channel", "channel_type", "page_master_tab", "visitor_login_status", "visitor_msisdn_hash", "visitor_customer_id", "visitor_id_hash", "visitor_subscription_type"])));
        break;
      }
    }

    setSelectedFilter(products_objectSpread(products_objectSpread({}, selectedFilter), {
      selectedCategory: curRange
    }));
    (0,filterService/* getProductsFilterByRange */.uF)(curRange).then(reloadPageData);
  };

  (0,react.useEffect)(function () {
    var _selectedFilter13, _selectedFilter14;

    var curCategoryId = ((_selectedFilter13 = selectedFilter) === null || _selectedFilter13 === void 0 ? void 0 : _selectedFilter13.selectedCategory) || ((_selectedFilter14 = selectedFilter) === null || _selectedFilter14 === void 0 ? void 0 : _selectedFilter14.selectedProductRange);

    if (categoryList && curCategoryId) {
      var _categoryList$categor2;

      categoryList === null || categoryList === void 0 ? void 0 : (_categoryList$categor2 = categoryList.categories) === null || _categoryList$categor2 === void 0 ? void 0 : _categoryList$categor2.map(function (category) {
        if (Number(category.id) === Number(curCategoryId)) {
          setSelectedCategory(selectedCategory = category);
        }
      });
    } else {
      setSelectedCategory(selectedCategory = null);
    }
  }, [categoryList, (_selectedFilter15 = selectedFilter) === null || _selectedFilter15 === void 0 ? void 0 : _selectedFilter15.selectedCategory, (_selectedFilter16 = selectedFilter) === null || _selectedFilter16 === void 0 ? void 0 : _selectedFilter16.selectedProductRange]);

  var getMaxPrice = function getMaxPrice() {
    if (isEligible()) {
      var _props$upgrade5, _props$upgrade5$credi;

      if (props !== null && props !== void 0 && (_props$upgrade5 = props.upgrade) !== null && _props$upgrade5 !== void 0 && (_props$upgrade5$credi = _props$upgrade5.creditFilters) !== null && _props$upgrade5$credi !== void 0 && _props$upgrade5$credi.financeIndicator) {
        var _props$upgrade6, _props$upgrade6$credi;

        var total_monthly_payment = Number(props === null || props === void 0 ? void 0 : (_props$upgrade6 = props.upgrade) === null || _props$upgrade6 === void 0 ? void 0 : (_props$upgrade6$credi = _props$upgrade6.creditFilters) === null || _props$upgrade6$credi === void 0 ? void 0 : _props$upgrade6$credi.total_monthly_payment) || 0;

        if (total_monthly_payment > aggMaxPrice.monthly) {
          return aggMaxPrice.monthly;
        } else {
          return total_monthly_payment.toFixed();
        }
      } else {
        return aggMaxPrice.monthly;
      }
    } else {
      if (isMonthly()) {
        return aggMaxPrice.monthly;
      } else {
        return aggMaxPrice.once;
      }
    }
  }; // Upgrade Affordability methods


  (0,react.useEffect)(function () {
    var asPath = window.location.search;
    var newMaxPrice = getMaxPrice();
    var curPriceMinValue = 0;
    var curPriceMaxValue = newMaxPrice;

    if (curPriceMaxValue) {
      (0,filterService/* parseFilterQuery */.w6)(decodeURIComponent(asPath)).then(function (filterData) {
        setSelectedFilter(filterData);

        if (isEligible() && !asPath.includes("isShowQualifying=false")) {
          var _props$upgrade7, _props$upgrade7$credi;

          if (filterData !== null && filterData !== void 0 && filterData.monthlyPrice) {
            var _filterData$monthlyPr, _filterData$monthlyPr2;

            curPriceMinValue = (filterData === null || filterData === void 0 ? void 0 : (_filterData$monthlyPr = filterData.monthlyPrice) === null || _filterData$monthlyPr === void 0 ? void 0 : _filterData$monthlyPr.minValue) || 0;
            curPriceMaxValue = (filterData === null || filterData === void 0 ? void 0 : (_filterData$monthlyPr2 = filterData.monthlyPrice) === null || _filterData$monthlyPr2 === void 0 ? void 0 : _filterData$monthlyPr2.maxValue) || newMaxPrice;
          }

          initAggregationsMaxPrice(props === null || props === void 0 ? void 0 : (_props$upgrade7 = props.upgrade) === null || _props$upgrade7 === void 0 ? void 0 : (_props$upgrade7$credi = _props$upgrade7.creditFilters) === null || _props$upgrade7$credi === void 0 ? void 0 : _props$upgrade7$credi.total_monthly_payment, types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);
          setIsProductsUpgrade(true);
          setShowQualifyProducts(true);

          _setPriceType(types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);

          setMaxMonthlyPrice(newMaxPrice);

          _setPriceValue({
            minValue: curPriceMinValue,
            maxValue: curPriceMaxValue
          });

          (0,filterService/* getProductsFilterByPrice */.XD)({
            minValue: curPriceMinValue,
            maxValue: curPriceMaxValue,
            type: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
            isShowQualifying: "true"
          }).then(reloadPageData);
        } else {
          var isNotShowQualifying = router.asPath.includes("isShowQualifying=false");

          if (isEligible() && affordablePriceRange.length == 0) {
            var _props$upgrade8, _props$upgrade8$credi;

            initAggregationsMaxPrice(props === null || props === void 0 ? void 0 : (_props$upgrade8 = props.upgrade) === null || _props$upgrade8 === void 0 ? void 0 : (_props$upgrade8$credi = _props$upgrade8.creditFilters) === null || _props$upgrade8$credi === void 0 ? void 0 : _props$upgrade8$credi.total_monthly_payment, types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);
          }

          if (!isEligible() && (filterData === null || filterData === void 0 ? void 0 : filterData.isShowQualifying) == "true") {
            return (0,filterService/* resetMobileFilter */.XU)().then(reloadPageData);
          } else if ((isProductsUpgrade || isNotShowQualifying) && (filterData !== null && filterData !== void 0 && filterData.monthlyPrice || filterData !== null && filterData !== void 0 && filterData.price)) {
            /* get back */
            setShowQualifyProducts(false);
            setIsProductsUpgrade(false);

            _setPriceType("");

            var curMaxPrice = newMaxPrice;
            var curPriceType = types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF;

            if (filterData !== null && filterData !== void 0 && filterData.monthlyPrice) {
              var _filterData$monthlyPr3, _filterData$monthlyPr4;

              curMaxPrice = aggMaxPrice.monthly;

              _setPriceType(types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);

              curPriceType = types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY;
              curPriceMinValue = (filterData === null || filterData === void 0 ? void 0 : (_filterData$monthlyPr3 = filterData.monthlyPrice) === null || _filterData$monthlyPr3 === void 0 ? void 0 : _filterData$monthlyPr3.minValue) || aggMinPrice.monthly;
              curPriceMaxValue = (filterData === null || filterData === void 0 ? void 0 : (_filterData$monthlyPr4 = filterData.monthlyPrice) === null || _filterData$monthlyPr4 === void 0 ? void 0 : _filterData$monthlyPr4.maxValue) || curMaxPrice;
            }

            if (filterData !== null && filterData !== void 0 && filterData.price) {
              var _filterData$price, _filterData$price2;

              curMaxPrice = aggMaxPrice.once;

              _setPriceType(types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF);

              curPriceMinValue = (filterData === null || filterData === void 0 ? void 0 : (_filterData$price = filterData.price) === null || _filterData$price === void 0 ? void 0 : _filterData$price.minValue) || aggMinPrice.once;
              curPriceMaxValue = (filterData === null || filterData === void 0 ? void 0 : (_filterData$price2 = filterData.price) === null || _filterData$price2 === void 0 ? void 0 : _filterData$price2.maxValue) || curMaxPrice;
            }

            setMaxPrice(curMaxPrice);

            _setPriceValue({
              minValue: curPriceMinValue,
              maxValue: curPriceMaxValue
            });

            (0,filterService/* getProductsFilterByPrice */.XD)({
              minValue: curPriceMinValue,
              maxValue: curPriceMaxValue,
              type: curPriceType,
              isShowQualifying: "false"
            }).then(reloadPageData);
          } else {
            // loadProducts();
            setIsPageUpdated(true);
          }
        }
      });
    }
  }, [(_props$upgrade9 = props.upgrade) === null || _props$upgrade9 === void 0 ? void 0 : _props$upgrade9.upgradeCheckDone, (_props$upgrade10 = props.upgrade) === null || _props$upgrade10 === void 0 ? void 0 : _props$upgrade10.upgradeResponse, (_props$upgrade11 = props.upgrade) === null || _props$upgrade11 === void 0 ? void 0 : _props$upgrade11.selectedUpgradeResponse, (_props$upgrade12 = props.upgrade) === null || _props$upgrade12 === void 0 ? void 0 : (_props$upgrade12$cred = _props$upgrade12.creditFilter) === null || _props$upgrade12$cred === void 0 ? void 0 : _props$upgrade12$cred.financeIndicator, props === null || props === void 0 ? void 0 : props.userLoggedIn, // aggMaxPrice,
  priceFilterData]);

  var onBackButtonClick = function onBackButtonClick() {
    if (!isPageUpdated) setIsPageUpdated(true);
  };

  (0,react.useEffect)(function () {
    window.addEventListener("popstate", onBackButtonClick);
    return function () {
      window.removeEventListener("popstate", onBackButtonClick);
    };
  }, []);

  var handleShowQualifyProducts = function handleShowQualifyProducts(flag) {
    if (!flag) {
      (0,analyticsUtag/* link */.p4)({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: "".concat(pageName, ": deselect products I qualify for")
      });
      switchPriceToMonthly();
      (0,filterService/* getProductsFilterByPrice */.XD)({
        minValue: aggMinPrice.monthly,
        maxValue: aggMaxPrice.monthly,
        type: types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
        isShowQualifying: "false"
      }).then(reloadPageData);
    } else {
      (0,analyticsUtag/* link */.p4)({
        page_name: pageName,
        page_tool_event: "use",
        page_tool_name: "".concat(pageName, ": select products I qualify for")
      });

      if (affordablePriceRange.length == 0) {
        var _props$upgrade13, _props$upgrade13$cred;

        initAggregationsMaxPrice(props === null || props === void 0 ? void 0 : (_props$upgrade13 = props.upgrade) === null || _props$upgrade13 === void 0 ? void 0 : (_props$upgrade13$cred = _props$upgrade13.creditFilters) === null || _props$upgrade13$cred === void 0 ? void 0 : _props$upgrade13$cred.total_monthly_payment, types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);
      }

      var newMaxPrice = getMaxPrice();

      _setPriceType(types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY);

      setMaxMonthlyPrice(newMaxPrice);
      (0,filterService/* getProductsFilterByPrice */.XD)({
        minValue: affordablePriceRange.length ? affordablePriceRange[0] : aggMinPrice === null || aggMinPrice === void 0 ? void 0 : aggMinPrice.monthly,
        maxValue: newMaxPrice,
        type: Number(newMaxPrice) === aggMaxPrice.once ? types/* default.TYPE_ONCE_OFF */.Z.TYPE_ONCE_OFF : types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY,
        isShowQualifying: "true",
        skipPageNumber: true
      }).then(reloadPageData);
    }

    setShowQualifyProducts(flag);
  };

  (0,react.useEffect)(function () {
    props.displayHideUpgradeTopbanner(!showComp);
  }, [showComp]); //END:  Upgrade Affordability methods

  var pageHeading = filteredCategory && filteredCategory !== null && filteredCategory !== void 0 && filteredCategory.name ? filteredCategory.name : labels/* default.lbl_browse_all_prods */.Z.lbl_browse_all_prods;

  if (isEligible() && showQualifyProducts) {
    pageHeading = labels/* default.upgrade.lbl_products_qualify */.Z.upgrade.lbl_products_qualify;
  }

  var getValueRange = function getValueRange() {
    // TO DO cater for credit filter
    if (isEligible() && showQualifyProducts) {
      return affordablePriceRange;
    } else {
      return priceType && priceType === types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY ? priceFilterData.monthly : priceFilterData.once;
    } // return priceType && priceType === types.TYPE_MONTHLY
    //   ? priceFilterData.monthly
    //   : priceFilterData.once;

  };

  var getMissingValueRange = function getMissingValueRange() {
    if (isEligible() && showQualifyProducts) {
      return missingAffordablePriceRange;
    } else {
      return priceType && priceType === types/* default.TYPE_MONTHLY */.Z.TYPE_MONTHLY ? missingPriceFilterData.monthly : missingPriceFilterData.once;
    }
  };

  var getSelectedPriceFilter = function getSelectedPriceFilter() {
    var _selectedFilter17, _selectedFilter19;

    if ((_selectedFilter17 = selectedFilter) !== null && _selectedFilter17 !== void 0 && _selectedFilter17.monthlyPrice) {
      var _selectedFilter18;

      return Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.minValue) > Number(aggMinPrice.monthly) || Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.maxValue) < Number(aggMaxPrice.monthly) ? (_selectedFilter18 = selectedFilter) === null || _selectedFilter18 === void 0 ? void 0 : _selectedFilter18.monthlyPrice : null;
    } else if ((_selectedFilter19 = selectedFilter) !== null && _selectedFilter19 !== void 0 && _selectedFilter19.price) {
      var _selectedFilter20;

      return Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.minValue) > Number(aggMinPrice.once) || Number(priceValue === null || priceValue === void 0 ? void 0 : priceValue.maxValue) < Number(aggMaxPrice.once) ? (_selectedFilter20 = selectedFilter) === null || _selectedFilter20 === void 0 ? void 0 : _selectedFilter20.price : null;
    }

    return null;
  };

  (0,react.useEffect)(function () {
    var _selectedFilter21, _selectedFilter22;

    var curCategoryId = ((_selectedFilter21 = selectedFilter) === null || _selectedFilter21 === void 0 ? void 0 : _selectedFilter21.selectedCategory) || ((_selectedFilter22 = selectedFilter) === null || _selectedFilter22 === void 0 ? void 0 : _selectedFilter22.selectedProductRange);

    if (priceType && priceValue !== null && priceValue !== void 0 && priceValue.maxValue && allBrands !== null && allBrands !== void 0 && allBrands.length) {
      updateAggregations({
        type: priceType,
        minPrice: priceValue.minValue,
        maxPrice: priceValue.maxValue
      });
    } else if (curCategoryId && priceValue !== null && priceValue !== void 0 && priceValue.maxValue && allBrands !== null && allBrands !== void 0 && allBrands.length) {
      updateAggregations({
        minPrice: priceValue.minValue,
        maxPrice: priceValue.maxValue,
        endType: "range"
      });
    }
  }, [priceType, priceValue, (_selectedFilter23 = selectedFilter) === null || _selectedFilter23 === void 0 ? void 0 : _selectedFilter23.selectedCategory, (_selectedFilter24 = selectedFilter) === null || _selectedFilter24 === void 0 ? void 0 : _selectedFilter24.selectedProductRange]);
  (0,react.useEffect)(function () {
    var query = new URLSearchParams(window.location.search);
    var categoryId = query.get('range') || query.get('category');

    if (!categoryId) {
      setCmsLoading(false);
      return;
    }

    if (categoryId) dispatch((0,pageBuilderActions/* getCategoryCMSContent */.ts)(categoryId));

    if (categoryCmsContent !== null && categoryCmsContent !== void 0 && categoryCmsContent[categoryId]) {
      var _categoryCmsContent$c, _categoryCmsContent$c2, _categoryCmsContent$c3;

      setCategoryCMS((_categoryCmsContent$c = categoryCmsContent[categoryId]) === null || _categoryCmsContent$c === void 0 ? void 0 : _categoryCmsContent$c.content);
      setCategoryDisplayMode((_categoryCmsContent$c2 = categoryCmsContent[categoryId]) === null || _categoryCmsContent$c2 === void 0 ? void 0 : _categoryCmsContent$c2.displayMode);
      setCategoryName((_categoryCmsContent$c3 = categoryCmsContent[categoryId]) === null || _categoryCmsContent$c3 === void 0 ? void 0 : _categoryCmsContent$c3.name);

      if (!analytics && !viewExecuted && !cmsLoading) {
        var _categoryCmsContent$c4;

        (0,analyticsUtag/* view */.ei)(products_objectSpread({
          page_event: "view",
          page_name: "shopping: ".concat((_categoryCmsContent$c4 = categoryCmsContent[categoryId]) === null || _categoryCmsContent$c4 === void 0 ? void 0 : _categoryCmsContent$c4.name)
        }, (0,analyticsUtag/* getUtagData */.GS)(["page_channel", "page_master_tab", "visitor_login_status", "visitor_customer_id", "visitor_id_hash", "visitor_msisdn_hash", "visitor_subscription_type"])));
        setViewExecuted(true);
        setAnalytics(true);
      }

      setCmsLoading(false);
    } else if (categoryCmsContent) {
      setCmsLoading(false);
    }
  }, [categoryCmsContent, router.query]);
  return /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
    children: [/*#__PURE__*/(0,jsx_runtime.jsx)(Seo/* default */.Z, {
      title: seoMetaData === null || seoMetaData === void 0 ? void 0 : seoMetaData.title,
      content: seoMetaData === null || seoMetaData === void 0 ? void 0 : seoMetaData.description,
      url: seoMetaData === null || seoMetaData === void 0 ? void 0 : seoMetaData.canonical_url,
      keywords: seoMetaData === null || seoMetaData === void 0 ? void 0 : seoMetaData.keywords,
      robots: seoMetaData === null || seoMetaData === void 0 ? void 0 : seoMetaData.robots
    }), /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.CustomContainer, {
      id: "product-list-container",
      className: "main-container",
      children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Container, {
        className: "custom-container",
        children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
            md: 12,
            className: showComp ? "hide" : "",
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(BreadCrumb, {
              list: categoryDisplayMode === "PAGE" && categoryName ? (0,helperServices/* formatBreadCrumb */.x9)((0,breadcrumbService/* breadcrumbGenerator */.G)({
                link: "/",
                label: categoryName
              }).cmsPage) : (0,helperServices/* formatBreadCrumb */.x9)((0,breadcrumbService/* breadcrumbGenerator */.G)().productlist)
            })
          })
        }), categoryCMS && /*#__PURE__*/(0,jsx_runtime.jsx)("div", {
          className: "page-builder",
          children: /*#__PURE__*/(0,jsx_runtime.jsx)(PageBuilder, {
            html: categoryCMS
          })
        }), errorType && errorType !== null && errorType !== void 0 && errorType.isProductFetched && !(errorType !== null && errorType !== void 0 && errorType.isProductError) && categoryDisplayMode !== "PAGE" && !cmsLoading ? /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
          children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            children: categoryList && categoryList.categories && categoryList.categories.length ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              md: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductRangeContainer, {
                selectedFilter: selectedFilter,
                categoryList: categoryList.categories,
                hide: showComp,
                handleSelected: handleRangeChange
              })
            }) : ""
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
            children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
              md: 12,
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(BrowseContainer, {
                isDeal: false,
                hide: showComp,
                selectionFlag: filteredCategory && Object.keys(filteredCategory.length !== 0),
                heading: pageHeading,
                shortDescription: filteredCategory && filteredCategory.short_description ? filteredCategory.short_description : labels/* default.lbl_filter_text */.Z.lbl_filter_text,
                filterButton: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroup, {
                  headingName: "Filter Products",
                  toggleComps: function toggleComps(val) {
                    toggleHandler(val);
                  },
                  noShadow: true,
                  hide: showComp,
                  selectedSortVal: sortProductsBy
                }) // containerStyling="browse-bar-tablet-styling"

              })
            })
          }), isEligible() && !showComp && /*#__PURE__*/(0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(upgradeCheckBar/* default */.Z, {
                  type: "info",
                  className: "ecom-upgrade-banner products-upgrade-banner",
                  message: labels/* default.product_affordability.lbl_available_products */.Z.product_affordability.lbl_available_products
                })
              })
            }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
              className: "d-block d-lg-none",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(AffordabilityFilterToggle/* default */.Z, {
                  id: "chk_qualify_products",
                  checkboxLabel: labels/* default.product_affordability.lbl_qualify */.Z.product_affordability.lbl_qualify,
                  checkboxSubtext: props === null || props === void 0 ? void 0 : (_props$upgrade14 = props.upgrade) === null || _props$upgrade14 === void 0 ? void 0 : (_props$upgrade14$cred = _props$upgrade14.creditFilters) === null || _props$upgrade14$cred === void 0 ? void 0 : _props$upgrade14$cred.message,
                  handleCheck: handleShowQualifyProducts,
                  check: showQualifyProducts
                })
              })
            })]
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            children: !showComp && /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
              className: "filter-btn-group filter-btn-group-for-mobile",
              children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Row, {
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                  md: 12,
                  className: "spacing",
                  children: /*#__PURE__*/(0,jsx_runtime.jsx)(ButtonGroup, {
                    headingName: "Filter Products",
                    toggleComps: function toggleComps(val) {
                      toggleHandler(val);
                    },
                    noShadow: true,
                    hide: showComp,
                    selectedSortVal: sortProductsBy !== "" ? sortProductsBy : labels/* default.sortKeys.lbl_recommended */.Z.sortKeys.lbl_recommended
                  })
                })
              })
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "d-none d-lg-block",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Col, {
                lg: 3,
                xl: 3,
                children: [isEligible() && /*#__PURE__*/(0,jsx_runtime.jsx)(AffordabilityFilterToggle/* default */.Z, {
                  id: "chk_qualify_products_desktop",
                  checkboxLabel: labels/* default.product_affordability.lbl_qualify */.Z.product_affordability.lbl_qualify,
                  checkboxSubtext: props === null || props === void 0 ? void 0 : (_props$upgrade15 = props.upgrade) === null || _props$upgrade15 === void 0 ? void 0 : (_props$upgrade15$cred = _props$upgrade15.creditFilters) === null || _props$upgrade15$cred === void 0 ? void 0 : _props$upgrade15$cred.message,
                  handleCheck: handleShowQualifyProducts,
                  check: showQualifyProducts
                }), /*#__PURE__*/(0,jsx_runtime.jsx)(SearchContainer, {
                  errorType: errorType,
                  brands: allBrands,
                  promotions: allPromotions,
                  selectedSubCategories: selectedFilter.selectedSubCategory,
                  selectedCategory: selectedFilter.selectedCategory || selectedFilter.selectedProductRange,
                  handleSelectedCategory: handleSelectedCategory,
                  categoriesList: showComp ? categoryList : filteredCategories,
                  selectedFilter: selectedFilter,
                  priceValue: priceValue,
                  priceType: priceType,
                  valueRange: getValueRange(),
                  missingValueRange: getMissingValueRange(),
                  showQualifyProducts: isEligible() && showQualifyProducts,
                  onBrandChange: handleBrandChange,
                  onPromotionChange: handlePromotionChange,
                  onPriceTypeChange: handlePriceTypeChange,
                  onPriceChange: handlePriceChange,
                  onFilterReset: handleResetFilter,
                  onFilterChange: reloadPageData,
                  setSelectedFilter: setSelectedFilter,
                  maxPrice: maxMonthlyPrice,
                  onResetPrice: function onResetPrice() {
                    return handleResetFilter("price");
                  }
                })]
              }), productList && productList.products && productList.products.items ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                lg: 9,
                xl: 9,
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListContainer, {
                  errorType: errorType,
                  selectedBrands: selectedFilter.brands,
                  selectedPromotions: selectedFilter.promotions,
                  selectedPrice: getSelectedPriceFilter(),
                  items: productList.products.items,
                  sortBy: sortBy,
                  selectedSortFilter: sortProductsBy,
                  pageInfo: productList.products.page_info,
                  updateCurrentPage: updateCurrentPage,
                  totalItemsCount: productList.products.total_count,
                  selectedSortVal: sortProductsBy,
                  bannerData: bannerData,
                  isMonthly: isMonthly(),
                  isOnceOff: isOnceOff(),
                  setSelectedFilter: setSelectedFilter,
                  selectedCategory: selectedFilter.selectedCategory || selectedFilter.selectedProductRange,
                  showQualifyProducts: isEligible() && showQualifyProducts,
                  onFilterReset: handleResetFilter,
                  onFilterChange: reloadPageData,
                  onBrandChange: handleBrandChange,
                  onPromotionChange: handlePromotionChange,
                  onResetPrice: function onResetPrice() {
                    return handleResetFilter("price");
                  }
                })
              }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {})]
            })
          }), /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
            className: "spacing-top spacing-bottom d-block d-lg-none ",
            children: /*#__PURE__*/(0,jsx_runtime.jsxs)(DependencyHelper.Row, {
              children: [/*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                lg: 3,
                xl: 3,
                className: featureSelected === "filter" && "override",
                children: featureSelected === "filter" && /*#__PURE__*/(0,jsx_runtime.jsx)(SearchContainer, {
                  errorType: errorType,
                  className: "nav-gutter",
                  selectedFilter: selectedFilter,
                  hide: showComp,
                  show: changeState,
                  brands: allBrands,
                  promotions: allPromotions,
                  selectedCategory: selectedFilter.selectedCategory || selectedFilter.selectedProductRange,
                  categoriesList: showComp ? categoryList : filteredCategories,
                  handleSelectedCategory: handleSelectedCategory,
                  priceValue: priceValue,
                  priceType: priceType,
                  valueRange: getValueRange(),
                  missingValueRange: getMissingValueRange(),
                  showQualifyProducts: isEligible() && showQualifyProducts,
                  onBrandChange: handleBrandChange,
                  onPromotionChange: handlePromotionChange,
                  onPriceTypeChange: handlePriceTypeChange,
                  onPriceChange: handlePriceChange,
                  onFilterReset: handleResetFilter,
                  onFilterChange: reloadPageData,
                  setSelectedFilter: setSelectedFilter,
                  maxPrice: maxMonthlyPrice,
                  handleApplyFilter: handleApplyFilter,
                  getSelectedBrands: getSelectedBrands,
                  getSelectedPromotion: getSelectedPromotion,
                  getPriceType: getPriceType,
                  getSelectedPrice: getSelectedPrice,
                  setPriceType: function setPriceType() {
                    return _setPriceType("");
                  },
                  setPriceValue: function setPriceValue() {
                    return _setPriceValue({
                      minValue: 0,
                      maxValue: constants/* MAX_ONCE_OF */.X_
                    });
                  }
                })
              }), productList && productList.products && productList.products.items ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.Col, {
                lg: 9,
                xl: 9,
                className: "product-list-gutter",
                children: /*#__PURE__*/(0,jsx_runtime.jsx)(ProductListContainer, {
                  errorType: errorType,
                  selectedBrands: selectedFilter.brands,
                  selectedPromotions: selectedFilter.promotions,
                  selectedPrice: getSelectedPriceFilter(),
                  items: productList.products.items,
                  hide: showComp,
                  sortBy: sortBy,
                  selectedSortFilter: sortProductsBy,
                  show: changeState,
                  featureSelected: featureSelected,
                  pageInfo: productList.products.page_info,
                  totalItemsCount: productList.products.total_count,
                  updateCurrentPage: updateCurrentPage,
                  selectedSortVal: sortProductsBy,
                  bannerData: bannerData,
                  isMonthly: isMonthly(),
                  isOnceOff: isOnceOff(),
                  setSelectedFilter: setSelectedFilter,
                  selectedCategory: selectedFilter.selectedCategory || selectedFilter.selectedProductRange,
                  showQualifyProducts: isEligible() && showQualifyProducts,
                  onFilterReset: handleResetFilter,
                  onFilterChange: reloadPageData,
                  onBrandChange: handleBrandChange,
                  onPromotionChange: handlePromotionChange,
                  onResetPrice: function onResetPrice() {
                    return handleResetFilter("price");
                  }
                })
              }) : ""]
            })
          })]
        }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
          className: "error-container",
          children: errorType !== null && errorType !== void 0 && errorType.isProductError && !cmsLoading && productListLoaded.current && isPageUpdated ? /*#__PURE__*/(0,jsx_runtime.jsx)(ErrorCard/* default */.Z, {
            errorMsg: errorMessages,
            fullWidth: 1
          }) : ""
        })]
      }), !(props !== null && props !== void 0 && props.hidePromo) && props !== null && props !== void 0 && (_props$sections = props.sections) !== null && _props$sections !== void 0 && _props$sections.length && productList && productList.products && productList.products.items ? /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "deal-promotion",
        children: sections.map(function (component, index) {
          return (0,renderComponent/* renderComponent */.SO)(component, index);
        })
      }) : /*#__PURE__*/(0,jsx_runtime.jsx)(DependencyHelper.CustomContainer, {
        className: "pb-l"
      }), /*#__PURE__*/(0,jsx_runtime.jsx)(StickyBottomContainer, {
        hide: showComp
      })]
    })]
  });
};

ProductListPage.defaultProps = {
  userLoggedIn: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    hidePromo: state.displayHideFooter.hideFooter,
    profileData: state.navDetails.profileData,
    userLoggedIn: state.navDetails.isUserLoggedIn,
    profileLoading: state.navDetails.isProfileLoading,
    upgrade: state.upgrade
  };
};

var __N_SSP = true;
/* harmony default export */ var products = ((0,es/* connect */.$j)(mapStateToProps, {
  removeCompareProducts: productCompareAction/* removeCompareProducts */.xQ,
  displayHideUpgradeModal: upgradeAction/* displayHideUpgradeModal */.ex,
  fetchCreditFilters: upgradeAction/* fetchCreditFilters */.QV,
  updateUpgradeRedirect: upgradeAction/* updateUpgradeRedirect */.z9,
  displayHideUpgradeTopbanner: upgradeAction/* displayHideUpgradeTopbanner */.Od,
  updateProductGridReset: upgradeAction/* updateProductGridReset */.vo,
  toggleFilters: navAction/* toggleFilters */.aD
})((0,next_router.withRouter)(ProductListPage)));

/***/ }),

/***/ 74425:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "G": function() { return /* binding */ breadcrumbGenerator; }
/* harmony export */ });
/* harmony import */ var _components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28658);
/* harmony import */ var _config_labels__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(99599);
/* harmony import */ var _utils_helperServices__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(64036);



var breadcrumbGenerator = function breadcrumbGenerator(customBreadcrumb) {
  var _labels$Session_Keys, _getSessionStorage$, _labels$Session_Keys2;

  var productlistfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys === void 0 ? void 0 : _labels$Session_Keys.lbl_list_page_router_with_filters) ? (_getSessionStorage$ = (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)(_config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === null || _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z === void 0 ? void 0 : (_labels$Session_Keys2 = _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].Session_Keys */ .Z.Session_Keys) === null || _labels$Session_Keys2 === void 0 ? void 0 : _labels$Session_Keys2.lbl_list_page_router_with_filters)[0]) === null || _getSessionStorage$ === void 0 ? void 0 : _getSessionStorage$.products : "/shopping/products";
  var dealfilter =  true && (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") ? (0,_utils_helperServices__WEBPACK_IMPORTED_MODULE_2__/* .getSessionStorage */ .wJ)("deals") : "/shopping/deals";
  var router = (0,_components_atoms_DependencyHelper__WEBPACK_IMPORTED_MODULE_0__.useRouter)();
  var breadcrumbconfig = {
    productlist: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/products",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }],
    cmsPage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.link,
      label: customBreadcrumb === null || customBreadcrumb === void 0 ? void 0 : customBreadcrumb.label
    }],
    productdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }],
    productcompare: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-compare",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_compare_products */ .Z.BreadCrumbLabels.lbl_compare_products
    }],
    deals: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }],
    dealdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: dealfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_all_deals */ .Z.BreadCrumbLabels.lbl_browse_all_deals
    }, {
      link: "/shopping/deal-details-page/[id]",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_deal_details */ .Z.BreadCrumbLabels.lbl_deal_details
    }],
    dealselection: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: productlistfilter,
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_browse_products */ .Z.BreadCrumbLabels.lbl_browse_products
    }, {
      link: "/shopping/product-details/".concat(router.query.id),
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_product_details */ .Z.BreadCrumbLabels.lbl_product_details
    }, {
      link: "/shopping/deal-selection",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].lbl_select_deal */ .Z.lbl_select_deal
    }],
    orderhistory: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }],
    orderdetails: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/view-order-details",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_details */ .Z.BreadCrumbLabels.lbl_order_details
    }],
    trackorder: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/view-order-history",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_order_history */ .Z.BreadCrumbLabels.lbl_order_history
    }, {
      link: "/shopping/track-my-order",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_track_order */ .Z.BreadCrumbLabels.lbl_track_order
    }],
    upgradePage: [{
      link: "/",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_home */ .Z.BreadCrumbLabels.lbl_home
    }, {
      link: "/shopping/upgrade",
      label: _config_labels__WEBPACK_IMPORTED_MODULE_1__/* ["default"].BreadCrumbLabels.lbl_upgrade_page */ .Z.BreadCrumbLabels.lbl_upgrade_page
    }]
  };
  return breadcrumbconfig;
};

/***/ }),

/***/ 96902:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Lp": function() { return /* binding */ getNotAllowedRanges; },
/* harmony export */   "b0": function() { return /* binding */ getAffordablePriceFilterDataFromOptions; },
/* harmony export */   "kD": function() { return /* binding */ getPriceFilterDataFromOptions; }
/* harmony export */ });
/* unused harmony export findClosestPriceFilterValue */
/* harmony import */ var _builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

var getPriceFilterDataFromOptions = function getPriceFilterDataFromOptions(options) {
  var localPriceFilterData = options.reduce(function (total, opt) {
    return total.concat(opt === null || opt === void 0 ? void 0 : opt.value.split("_").map(function (val) {
      return Number(val);
    }));
  }, []);
  return (0,_builds_vodacomsa_digital_engineering_digital_channels_vodacom_dxl_web_aggregation_services_vod_ms_web_ui_ecom_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(new Set(localPriceFilterData));
};
var getNotAllowedRanges = function getNotAllowedRanges(options) {
  var localPriceFilterData = getPriceFilterDataFromOptions(options);
  var missingRangesArray = options.map(function (opt, index) {
    var _options;

    if (Number(opt.value.split("_")[1]) < Number((_options = options[index + 1]) === null || _options === void 0 ? void 0 : _options.value.split("_")[0])) {
      var _options2;

      return {
        min: localPriceFilterData.indexOf(Number(opt.value.split("_")[1])),
        max: localPriceFilterData.indexOf(Number((_options2 = options[index + 1]) === null || _options2 === void 0 ? void 0 : _options2.value.split("_")[0]))
      };
    }
  });
  var missingRanges = missingRangesArray.filter(function (val) {
    if (val) {
      return val;
    }
  });
  return missingRanges;
};
var findClosestPriceFilterValue = function findClosestPriceFilterValue(filterData, value) {
  var min = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  if (!value) return value;
  var numericValue = Number(value);

  for (var i = 0; i < filterData.length; i++) {
    var currentFilterData = Number(filterData[i]);

    if (currentFilterData == numericValue) {
      return i;
    } // if we find bigger we need to stop, calculate distance and return the correct one


    if (filterData[i] > numericValue) {
      return min ? i - 1 : i;
    }
  }

  return filterData.length - 1;
};
var getAffordablePriceFilterDataFromOptions = function getAffordablePriceFilterDataFromOptions(options, max) {
  var fixedVal = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  var newArr = options.filter(function (value) {
    return value <= max;
  });
  var newMax = Number(fixedVal) > Number(max) ? max.toFixed() : fixedVal;

  if (newArr.length == 0) {
    newArr = [0, Number(newMax)];
  } else if (newArr.length == 1 && newArr[0] === 0) {
    newArr.push(Number(newMax));
  }

  if (newArr[newArr.length - 1] < newMax) {
    newArr.push(Number(newMax));
  }

  return newArr;
};

/***/ }),

/***/ 32782:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shopping/products",
      function () {
        return __webpack_require__(123);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78328:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"linkButton":"buttonItem_linkButton__bPlY7"};

/***/ }),

/***/ 43772:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"column_root__VIgYZ"};

/***/ }),

/***/ 390:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"columnGroup_root__pIuM_"};

/***/ }),

/***/ 37699:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"columnLine_root__q12_V"};

/***/ }),

/***/ 82000:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"row_root__z9Yzc","contained":"row_contained__tfaZ1 row_root__z9Yzc","fullBleed":"row_fullBleed__8xWO4 row_root__z9Yzc","videoOverlay":"row_videoOverlay__WvTS_"};

/***/ }),

/***/ 31338:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"root":"text_root__MRqeZ"};

/***/ }),

/***/ 56209:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"upgrade-check-bar":"upgradeCheckBar_upgrade-check-bar__Qqp_9","message":"upgradeCheckBar_message__sBV34","ctaBtn":"upgradeCheckBar_ctaBtn__S1JhB","upgrade-check-bar-success":"upgradeCheckBar_upgrade-check-bar-success__938HG","upgrade-check-bar-info":"upgradeCheckBar_upgrade-check-bar-info__e2NVC"};

/***/ }),

/***/ 90609:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"error-card-block":"ErrorCard_error-card-block__a5i2d","error-sub-text":"ErrorCard_error-sub-text__SOeNv","error-card-image":"ErrorCard_error-card-image__UNBmk","error-card":"ErrorCard_error-card__uAWyz","error-card__heading":"ErrorCard_error-card__heading__BvUl0","error-card__subheading":"ErrorCard_error-card__subheading__JxMX_"};

/***/ }),

/***/ 41708:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapper-checkbox":"AffordabilityFilterToggle_wrapper-checkbox__aMtlJ","item-label":"AffordabilityFilterToggle_item-label__8Qt8a"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1216,8434,4309,8005,8282,8375,9327,5887,9774,2888,179], function() { return __webpack_exec__(32782); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);